export default {
    "corporate": "Corporate program",
    "onboarding": {
        "goal_desc": "You’ll earn %{customPoints} for tracking your activity and bonus %{customPoints} for completing your goals. It’s time to get started! You can have 3 personal goals active at any one time.",
        "sample_task": {
            "modalActivityTitle": "3 deep breaths",
            "rewards_featured_title": "Featured",
            "rewards_partners_title": "Partners",
            "header_description": "You’ll earn %{customPoints} by tracking your activity and completing tasks, goals, and challenges.",
            "icon_text": "Tap the {icon} to track a deep breath.",
            "activityName": "deep breathing",
            "activityUnit": "breath"
        },
        "lets_get_started": "Let's get started!",
        "start_description": "You’ll earn %{customPoints} by tracking your activity and completing tasks, goals, and challenges.",
        "complete_and_earn": "Complete and earn",
        "did_it": "I did it!",
        "task_complete": "Task completed!",
        "breath_sample_task": "Take a quick tutorial about activity tracking",
        "track_a_sample_activity": "Track a sample activity",
        "nice": "Nice!",
        "nice_one": "Nice one!",
        "nice_subtext_1": "You’ve earned %{points} %{customPoints}.",
        "nice_subtext_2": "Earning %{customPoints} will help you level up. Each time you move up a level, you'll earn %{reward_currency}, which can be redeemed for great offers.",
        "nice_subtext_3": "You'll earn more points when you complete more tasks, track activity, and complete goals and challenges.",
        "progress_subtitle": "Your %{customPoints} and progress reset every %{frequency}.",
        "skip_for_now": "Skip for now",
        "loadingText": "Hang tight while we calculate your wellbeing score.",
        "goal_title": "Set a personalized goal",
        "swipe_for_more": "Swipe to see more",
        "skip_goals": "I’m done setting goals for now.",
        "complete_profile": "",
        "level": "Level",
        "finish_onboarding_action": "Please complete onboarding first",
        "vital_stats": {
            "height_ft": "Height ft.",
            "height_in": "Height in."
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "Your privacy is important"
        },
        "levels": {
            "title": "Achievements and rewards",
            "tableTitle": "Achievement"
        },
        "initialScreen": {
            "title": "Welcome to %{programName}, %{username}!",
            "getRewarded": "Get rewarded with %{rewardName}",
            "completeAgainst": "Compete against your colleagues",
            "earnPoints": "Earn points with wellness activities",
            "levelUp": "Level up and unlock badges"
        },
        "starterGoals": {
            "title": "Choose a goal",
            "subtitle": "Kick off your wellbeing journey with a new healthy habit."
        }
    },
    "healthkit_not_available": "Unable to connect with Apple Health. In the Health app, under Sources, ensure you have at minimum enabled permission to steps and have at least 1 step tracked.",
    "changeCover": "Change photo",
    "joiningCommunityToast": {
        "success": {
            "message": "You have successfully joined %{name}",
            "title": "Join community"
        }
    },
    "achievement_starts_date": "Starts: %{date}",
    "editChallenge": "Edit %{challengeName}",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "Choose up to 5 activities",
            "title": "What would you like to do?",
            "noActivityTitle": "Adding activities",
            "noActivityMessage": "Select at least one activity or category.",
            "categoryItemDescription": "All activities in %{category} category",
            "addActivityTitle": "How many %{unit} of %{activity} do you want to do per %{period}?",
            "addCategoryQuantityTitle": "How many %{customPoints} do you want to earn in %{category} category?",
            "subtitleCategories": "Select one category. All activities from that category will contribute to the goal.",
            "subtitleWithActivities": "%{num} of %{max} activities selected",
            "selectCategoryMessage": "All activities in the category will be selected and the previously selected activities will be discarded.",
            "addActivityTitleTotal": "How much %{activity} do you want to do in %{period}?"
        },
        "inviteDepartments": {
            "title": "Invite departments \/ division"
        },
        "inviteRegions": {
            "title": "Invite regions"
        },
        "createInvitation": {
            "selectMore": "Please select at least 2 %{entity}s!"
        },
        "visibility": {
            "title": "Visibility",
            "description": "Team challenges can be found and joined by all %{programName} users."
        },
        "highest": {
            "name": "Most %{customPoints} wins",
            "description": "No limits, highest %{customPoints} takes 1st place"
        },
        "compete": {
            "individual": "Compete as an individual",
            "team": "Compete as a team"
        },
        "unitType": {
            "title": "Select how you complete your goal",
            "subtitle": "Choose from activities or a category"
        },
        "category": {
            "name": "All activities in a category",
            "description": "E.g. Track any activity in 'Move'",
            "title": "Choose a category",
            "subtitle": "From which category will you be tracking activities?"
        },
        "activities": {
            "name": "Selected activities",
            "description": "E.g. Track specific activities like cycling",
            "title": "Choose activities",
            "subtitle": "We recommend focusing on a single activity but you can add up to 5",
            "maxModalTitle": "Maximum activities selected",
            "maxModalDescription": "You can add at most 5 activities. Tap Accept to proceed with your 5 selected activities or Edit to make changes.",
            "warningModalTitle": "High difficulty",
            "warningModalDescription": "You have specified a lot of activity to complete per period in this goal. Are you sure you want to set such a challenging goal?",
            "requiredPoints": "required to meet %{period} %{challengeType}",
            "noActivitiesModalTitle": "Adding activities",
            "noActivitiesModalDescription": "Select at least one activity."
        },
        "categoryQuantity": {
            "title": "Set your %{customPoints} goal",
            "subtitle": "How many %{customPoints} do you want to earn from %{category} each %{period}?",
            "subtitleTotal": "How many %{customPoints} do you want to earn from %{category} %{period}?",
            "text": "As a guideline, 30 minutes of moderate activity is equal to about 105 %{customPoints}",
            "noQuantityModalTitle": "Quantity",
            "noQuantityModalDescription": "Enter a value",
            "defaultCategoryTitle": "current category"
        },
        "cancel": {
            "title": "Cancel challenge creation",
            "message": "Are you sure you want to cancel challenge creation?"
        },
        "createNew": "Create new challenge",
        "chooseChallengeTitle": "Choose a challenge or create your own",
        "createOwn": {
            "title": "Create my own"
        },
        "frequency": {
            "title": "How frequently will you meet your goal?",
            "subtitle": "Daily goals are great habit builders"
        },
        "startAndDuration": {
            "title": "Choose a start date and duration",
            "subtitle": "",
            "noFieldsTitle": "Start date and duration",
            "noFieldsMessage": "Please fill in start date and duration"
        },
        "finalize": {
            "title": "Review your new goal",
            "subtitle": "",
            "noFieldsTitle": "Name and instructions",
            "noFieldsMessage": "Please fill in name and instructions",
            "name": "My %{frequency} %{names} goal",
            "instructionCategory": "Earn %{points} %{customPoints} %{frequency} from all %{category} activities",
            "instructionActivities": "Track %{items} %{frequency} and earn %{points} %{customPoints} %{pointsFrequency}",
            "instructionCompetitionCategory": "Get the most %{customPoints} from all %{category} activities to win this competition",
            "instructionCompetitionActivities": "Get the most %{customPoints} from %{items} to win this competition",
            "namePlaceholder": "Name your competition",
            "titleChallenge": "Finalize your challenge"
        },
        "dailyDescription": "E.g. Drink 8 glasses of water each day",
        "weeklyDescription": "E.g. Walk 150 mins each week",
        "monthlyDescription": "E.g. Run 150 kms each month",
        "totalDescription": "E.g. Cycle a total of 10,000 kms",
        "title": "Challenge yourself or others?",
        "navigatorTitle": "Create a challenge",
        "me": {
            "name": "Just myself",
            "description": "Challenge yourself with a personal goal"
        },
        "others": {
            "name": "Compete with others",
            "description": "Compete individually or as a team"
        },
        "one": {
            "name": "Individually",
            "description": "Complete individually with other users"
        },
        "team": {
            "name": "As a team",
            "description": "Complete as a team with other teams"
        },
        "company": {
            "name": "Company challenge",
            "description": "Create special competition"
        },
        "adminItemTitle": "As an administrator, you can create",
        "userOrTeamTitle": "Compete individually or as a team?",
        "target": {
            "name": "Set a target to meet",
            "description": "Challenge that has an upper limit"
        },
        "typeTitle": "Choose a %{challengeType} type",
        "teamSizeTitle": "Choose a size for each team",
        "teamSizeSubtitle": "The minimum size of a team is %{min} and the maximum is %{max}. Your team's %{customPoints} are the average of all members in the team and you can only earn %{customPoints} when your team has met the minimum number of members.",
        "teamSize": {
            "noFieldsTitle": "Min and max",
            "noFieldsMessage": "Choose the minimum and maximum number of members to a team"
        },
        "companyChallengeTitle": "Company challenge",
        "companyChallengeSubtitle": "You’re an admin. You can set up departmental and other types of challenges",
        "chooseDepartmentTitle": "Choose departments \/ divisions to compete",
        "chooseRegionTitle": "Choose regions to compete",
        "goToChallenge": "Go to my challenge",
        "additional": {
            "title": "Challenge created",
            "subtitle": "Let's get started! Invite others to join.",
            "makePublicName": "Make this public",
            "makePublicDescription": "Anyone can join",
            "toDirectoryName": "Submit to the Challenge Directory",
            "toDirectoryDescription": "People can create one just like this",
            "inviteTitle": "Invite to challenge",
            "titleGoal": "Goal created!"
        },
        "quantityMinimum": {
            "message": "The minimum required quantity is %{quantity}",
            "title": "Insufficient Quantity"
        },
        "toast": {
            "success": "Your %{challengeType} has been created."
        },
        "goToGoal": "Go to my goal",
        "navigatorTitleGoal": "Create a goal",
        "quantityError": {
            "wholeNumber": "Must be a whole number",
            "greaterThanZero": "Must be greater than 0"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "Your wellbeing score is calculated by comparing the answers you provided in the wellbeing survey to those of millions of other people in the same age and gender category as you. Your score demonstrates where you rank relative to them. Your score will automatically update each month according to changes in your move, eat and feel behaviours that are entered in the app. Consistent goal setting and taking positive action to improve your health can help increase your wellbeing score.",
            "excellent": "Your health score is better than 85% of people your age and sex. ",
            "very_good": "Your health score is better than 70-84% of people your age and sex.",
            "good": "Your health score is better than 51-69% of people your age and sex.",
            "fair": "Your health score is better than 31-50% of people your age and sex.",
            "poor": "Your health score is lower than 70% of people your age and sex. It's never too late to start prioritizing your health. Take advantage of our platform to help you progress in your wellness journey!",
            "overall_result": "Overall, your wellbeing score is %{status}.",
            "category_result": "Overall, your {category} score is {string}.",
            "goals": "You can’t win without goals. Set up to 3 personal goals and track towards them. Over time as you make lifestyle changes you’ll see your score rise."
        },
        "reminder": {
            "title": "It's time to update your wellbeing survey!",
            "updateAnswers": "Update my answers"
        },
        "lastUpdated": "Last updated %{date}",
        "scoreDescription": {
            "part1": "Your score is",
            "part2": "score of",
            "belowAverage": "below the average",
            "aboveAverage": "above the average",
            "part3": "for others your age and sex."
        },
        "improveScore": {
            "description": "Your score is calculated based on your wellbeing survey answers and tracked activity. You can update your survey answers or set new goals to improve.",
            "desc1": "Your score can’t get much higher! To keep your routines interesting, challenge yourself with targets just beyond your normal capability, and invite others to compete with you to stay motivated.",
            "desc2": "If you’re ready to level up, it’s time to increase the challenge. Challenge yourself with targets just beyond your normal capability, and invite others to compete with you to stay motivated.",
            "desc3": "Set personal goals and create public challenges to hold yourself accountable and maintain motivation. Be sure to choose achievable targets and smaller time frames – we recommend 1 week.",
            "desc4": "It’s important to be active every day. If you don’t have much movement in your daily routine, start with small goals that match your abilities and interests. Be sure to choose achievable targets and smaller time frames – we recommend 1 week."
        },
        "recommendedGoals": "Recommended goals",
        "recommendedDescription": {
            "desc1": "Set up to ",
            "desc2": "3 goals ",
            "desc3": "to focus on improving your wellbeing. You currently have "
        },
        "categoryScore": "Your %{category} score is ",
        "learnMore": "Learn more",
        "youAreSet": "You're set!",
        "goalSetting": "Goal setting",
        "attention": "%{category} score not available.",
        "move": {
            "error": "Based on your answers your move score is not available. "
        },
        "eat": {
            "error": "You indicated a healthcare professional has told you that you have Type 2 Diabetes and it's unmanaged. "
        },
        "feel": {
            "error": "Based on your answers your feel score is not available. "
        },
        "survey": {
            "requiredField": "* this field is required"
        },
        "score_info_title": "What my score means",
        "company_average_info": "Average at my company",
        "demographic_average_info": "Average in my demographic",
        "score": "Wellbeing score",
        "table": {
            "what_it_means": "What it means",
            "score": "Score"
        },
        "updated": "Updated",
        "label": {
            "excellent": "Excellent",
            "very_good": "Very good",
            "good": "Good",
            "fair": "Fair",
            "poor": "Poor"
        },
        "activity": {
            "eat": "Eat Activity 1, Eat Activity 2, Eat Activity 3",
            "move": "Move Activity 1, Move Activity 2, Move Activity 3",
            "feel": "Feel Activity 1, Feel Activity 2, Feel Activity 3"
        },
        "score_info_screen": "How is my score calculated?",
        "details": "Details",
        "activities": "Activities",
        "improveCategoryScore": "Improve my %{category} score",
        "meaning": {
            "heading": "Score calculation"
        },
        "score_button": {
            "meaning": "What does this score mean?"
        },
        "improve": "See recommended goals",
        "score_text": {
            "demographic": "The average score for your age and sex is",
            "company": "and the average score at your company is"
        },
        "scoreHigher": "higher than the average of",
        "scoreLower": "lower than the average of",
        "settedGoals": {
            "noGoals": "No goals set",
            "one": "1 goal set",
            "n": "%{count} goals set"
        },
        "yourScoreIsPoor": "Your %{category} score is poor",
        "unlock": {
            "title": "Unlock your wellbeing score",
            "description": "Complete a brief questionnaire to learn how your overall health compares to other people in your demographic."
        },
        "browseAndSet": "You can browse and set new goals after your current ones have finished.",
        "excellent": {
            "desc1": "Exceptionally healthy lifestyle",
            "desc2": "Very low health risk"
        },
        "veryGood": {
            "desc1": "Very healthy lifestyle",
            "desc2": "Low health risk"
        },
        "good": {
            "desc1": "Healthy lifestyle",
            "desc2": "Average health risk"
        },
        "fair": {
            "desc1": "Somewhat healthy lifestyle",
            "desc2": "Above average health risk"
        },
        "poor": {
            "desc1": "High health risk",
            "desc2": "More daily movement is recommended",
            "desc3": "More daily movement is needed"
        },
        "calculateScore": {
            "description": "When you complete the wellbeing survey, your responses are analyzed using billions of data variables from people your age and sex. The calculation also factors in the activity you track in %{programName}.\n\nYour wellbeing score updates regularly so you can see it change over time."
        },
        "improveYourScore": "Improving your score"
    },
    "challengerCount": "%{num} challengers",
    "team_name": "Team name",
    "syncingDeviceToast": {
        "danger": {
            "message": "Oops… We had a problem syncing %{name}. Please try again.",
            "title": "Sync"
        },
        "success": {
            "title": "Sync",
            "message": "Successfully synced %{name}. Your activities are now up to date."
        }
    },
    "allCompanyMembers": "All company members",
    "allCompanyMembersTeam": "All company members (Team)",
    "successfullyRedeemedItemForConfirmation": "You've successfully redeemed this item and a confirmation email has been sent to %{email}.",
    "no_all_events_placeholder": "It seems like there are no events available to join at this time. Why don't you create one?",
    "confirmDeleteAccount": "Confirm deletion by entering the email address associated with your account",
    "deleteAccount": "Delete account",
    "linkAccounts": "Manage linked accounts",
    "titleSlug": {
        "icon_reward_text": "It’s easy for eligible members to earn more points by shopping with our partners, or on a check-up at a Members’ Choice Advantage dentist using their extras cover.",
        "icon_move_text": "Tracking everyday healthy choices like sleeping better or eating veggies could earn you Live Better Points.",
        "icon_redeem_text": "Live Better rewards Medibank members who have hospital or extras cover for looking after their health. ",
        "icon_phone_text": "Sign up and be on your way to redeem rewards, like health and wellbeing gift cards or saving on your health cover. ",
        "wellness": "Welcome to the world of wellness",
        "goals": "Achieve your goals",
        "devices": "Stay on track",
        "challenges": "Create challenges",
        "celebrate": "Social wellness",
        "habits": "Build healthy habits",
        "joinChallenge": "Join the challenge",
        "getSocial": "Get social",
        "reward": "Get rewarded for living a healthier life.",
        "move": "Move, eat & feel better.",
        "phone": "Live better, feel better."
    },
    "viewProgress": {
        "goal": "View goal progress",
        "challenge": "View challenge progress",
        "progress": "View progress"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "Entering this information is optional, for your own benefit, and private to you."
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} bonus %{customPoints} are available for this event!"
        },
        "modal": {
            "paragraph1": "By attending this event you will earn bonus %{pointsName}.",
            "paragraph2": "All bonus %{pointsName} are awarded after the event has completed. You won't receive bonus credits for events that you do not attend."
        }
    },
    "EAP": {
        "contactInfo": "Contact information",
        "doLater": "I'll do this later",
        "tellMore": "Tell me more",
        "contactMe": "Contact me",
        "title": "Employee & family assistance program",
        "reachGoal": {
            "title": "Help is available",
            "description": "Your Employee and Family Assistance Program (EFAP), provided by %{providerName}, offers a variety of health coaching services to help you achieve your wellbeing goals.\n\nWould you like %{providerName} to contact you with more information?"
        },
        "privacyPolicy": "%{provider} Privacy Policy"
    },
    "HRIS": {
        "disclaimer": "This information is set automatically and can’t be changed"
    },
    "settingGoals": {
        "description": "Focusing on 3 recommended goals at a time will increase your likelihood of success.",
        "title": {
            "one": "You have 1 goal set"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "Account already linked to a different user",
            "lastAccountMessage": "Are you sure you want to remove your last linked account? Once removed you must log in with email address %{email} and a new password.",
            "unlinkCorpAccountMessage": "Are you sure you want to remove your corporate linked account? Once removed you must log in with email address %{email} again.",
            "alreadyLinked": "Account already linked",
            "unlinkMessage": "Are you sure you want to remove a linked account?"
        },
        "sso": {
            "emailNotVerified": "Your email is not verified."
        },
        "signIn": {
            "dontHaveAccount": "Don't have an account?",
            "enterPIN": "Enter your company Program Identification Number",
            "dontKnowPIN": "Don't know your PIN?",
            "pin": "PIN",
            "register": "Register",
            "pinDescription": "Contact your program administrator if you are unsure of your organization's unique Program Identification Number (PIN). If you have a PIN and have difficulties with proceeding to the next step, contact support@sproutatwork.com.",
            "keepMeTooltip": "For your convenience, when this box is checked your session will remain valid for 30 days. On shared devices, we recommend that you uncheck this box and sign out when you are done."
        },
        "signUp": {
            "backToLogin": "Back to login",
            "termsOfService": "Terms of service",
            "privacyPolicy": "Privacy policy"
        },
        "createYourAccount": "Create your account ",
        "setYourDetails": "Set your details",
        "ModaHybridLogin": {
            "noAccessDashboard": "Walang access sa Dashboard ng Miyembro?",
            "signUpSSOButton": "Mag-sign up sa pamamagitan ng Moda Member Dashboard",
            "noAccessDashboardWeb": "Kung wala kang access sa Dashboard ng Miyembro, mag-log in gamit ang iyong email at password sa ibaba.",
            "loginSSOButton": "Mag-log in sa pamamagitan ng Moda Member Dashboard"
        }
    },
    "entityHasBeenDeleted": "%{name} has been deleted",
    "track_challenge": {
        "message": {
            "manually": "Track manually",
            "automatically": "Tracked automatically with %{appOrDeviceName}",
            "manuallyOrConnect": "Track manually or connect an app or device",
            "manuallyAndBy": "Track manually and automatically with %{appOrDeviceName}",
            "reconnectDevice": "Device required. Please reconnect your device",
            "manualAndAuto": "Track manually and automatically",
            "trackedAutomatically": "Tracked automatically"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "Unable to sign up",
            "message": "Unable to retrieve user details from partner. Please try again later"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "An app or device is required for this %{goalName}.",
            "subTitle": "Please connect an app or device"
        }
    },
    "descriptionSlug": {
        "wellness": "Join the health community that helps you set goals, connect and stay on track.",
        "goals": "Tell us what you're working towards.  We'll help you get there with recommended goals.",
        "devices": "Sync your fitness device or log your activities and keep your wellness goals on track.",
        "challenges": "Spark some friendly competition.  Create a challenge and invite others to join the fun.",
        "celebrate": "Stay connected with colleagues and celebrate your successes together.",
        "habits": "Track wellness activities to earn points. Link to your phone or wearable to earn faster.",
        "joinChallenge": "See how you stack up against your coworkers in friendly competitions.",
        "getSocial": "Stay connected with colleagues and celebrate your successes together.",
        "reward_text": "Earn points for completing daily activities and personal challenges.",
        "move_text": "Whether it’s a walk around the block, five minutes of mindfulness or a streak of healthy eating, you’ll be rewarded.",
        "phone_text": "Use your points for discounts on your cover and great offers, the choice is yours.",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "Feature not enabled",
        "checkAppVersion": {
            "message": "It looks like your app is out of date. Please install the latest update.",
            "button": "Update %{appName}"
        },
        "noConnection": {
            "title": "No network connection",
            "description": "It looks like you are not connected to the internet. You won't be able to fully use the application unless you have a connection.",
            "button": "Retry"
        },
        "uploadPhotoText": "Add a photo for your %{entityType}",
        "entities": {
            "community": "community",
            "event": "event",
            "team": "team",
            "goal": "goal",
            "challenge": "challenge",
            "competition": "competition"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "Unable to log in",
            "resetPasswordHeading": "Password Reset Required"
        },
        "signup": {
            "corporateOrOther": "Not a Medibank member? Or part of a corporate program?",
            "sign_up_here": "Sign up here ",
            "errorHeading": "Unable to sign up",
            "areYouMedibankMember": "Are you a Medibank member?",
            "isMedibankMember": "I am a member",
            "isNotMedibankMember": "I am not a member"
        },
        "bpidExists": "The email provided is already associated with a live better user, email must be unique.",
        "generalError": "Service currently unavailable"
    },
    "rewardsNoAvailableProducts": "There are no available products at this time.",
    "endedGoal": {
        "timeToTrack": {
            "yes": "You still have time to track!",
            "no": "Your %{type} has ended"
        },
        "grace": "Your %{type} may have ended, but you have %{n} %{text} to track any forgotten activity",
        "notGrace": {
            "goal": "Congratulations on completing your goal! Keep up the great work by setting a new goal to stay on track with your wellness.",
            "competition": "Congratulations on completing the challenge! Keep your momentum by joining another challenge, or creating your own."
        }
    },
    "appDeviceModal": {
        "defaultMessage": "Connect your device or app and enjoy seamless tracking. Your authentication allows our technology partner \"Sprout\" to securely transfer your data from your %{appDeviceTitle} account."
    },
    "noTransactionsMessage": "It looks like you have not made any transactions.",
    "noRedemptionsMessage": "It looks like you have not yet made any redemptions.",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "You can compete in challenges as an individual, or as a team",
            "prompt": "There are no challenges to join right now. Why not create one?"
        },
        "createChallengeButton": "Create a challenge"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "Events can be invite-only or open to anyone.",
            "button": "Create an event"
        },
        "emptyEventsMessage": "There are no events to join right now. Why not create one?"
    },
    "appnameLiveBetter": "Live Better",
    "appnameTelus": "Wellbeing",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "You don't have any goals set!",
            "descriptionNoSet": "Improve your wellbeing score by setting some goals. Get started quickly with a recommended goal, choose from the catalogue, or create your own.",
            "descriptionSet": "You can set one of the recommended goals we have just for you, browse the complete catalogue, or create your own goal.",
            "action_text": "Set a new goal",
            "heading_singular": "You can set 1 more goal",
            "heading_plural": "You can set %{number} more goals"
        },
        "heading": "Personal goals",
        "single": "Personal goal"
    },
    "settingGoal": {
        "yourGoal": "Your %{units}",
        "yourGoalDescription": "You're on your way! The following %{units} will be set and will start right away.",
        "selectedGoals": "Selected goals",
        "recommendedDescription": {
            "maximumSet": "You have the maximum number of goals set. You can browse and set new goals after your current ones have finished.",
            "maximumSetTitle": "You have %{count} goals set"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "The activity has been removed",
            "info": "Something went wrong. Please try again.",
            "danger": "Something went wrong. Please try again."
        },
        "plural": {
            "success": "Activities have been removed",
            "info": "Something went wrong. Please try again.",
            "danger": "Something went wrong. Please try again."
        },
        "success": "The activity has been removed",
        "info": "The activity was not removed. Please try again.",
        "danger": "The activity was not removed. Please try again."
    },
    "participants": "Participants",
    "members": "Member(s)",
    "timeSittingInformationOld": "Guidelines recommend to:\n- Minimise the amount of time spent in prolonged sitting.\n- Break up long periods of sitting as often as possible.",
    "timeSittingInformation": {
        "title": "Guidelines recommend to:",
        "list": "- Minimise the amount of time spent in prolonged sitting.\n- Break up long periods of sitting as often as possible."
    },
    "activityLevelInformationOld": "Guidelines recommend:\n- Being active on most, preferably all, days every week.\n- Accumulate over 150 minutes of moderate intensity physical activity each week.\n- Do muscle strengthening activities on at least 2 days each week.",
    "activityLevelInformation": {
        "title": "Guidelines recommend:",
        "list": "- Being active on most, preferably all, days every week.\n- Accumulate over 150 minutes of moderate intensity physical activity each week.\n- Do muscle strengthening activities on at least 2 days each week."
    },
    "viewGuidelines": "View guidelines",
    "corporateAccountLink": {
        "verification": {
            "title": "Verify your work email address",
            "description": "You'll need to verify your work email address to successfully complete the linking process. Please follow the instructions sent to:"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "Find friends & family",
        "findFriends&Family": "Find friends & family",
        "tapToAddFriendsAndFamily": "Tap to add to friends & family",
        "addedFriendsAndFamily": "Added to friends & family",
        "whoYouAreLookingFor": "Don't see who you are looking for?",
        "inviteWithEmail": "Invite with email",
        "sentInvitations": "Sent invitations",
        "foundPerson": "We found this person with a matching email",
        "youAreBoth": "You are both in %{entityName}",
        "youAreBothMore": "You are both in %{entityName}, +%{n} more",
        "noFriendsAndFamilyAdded": "It looks like you don't have any friends or family added yet.",
        "sendInvitation": "Send invitation",
        "youHaveNoSentInvitations": "You have not sent any invitations",
        "toast": {
            "success_title": "Invitation sent",
            "success_description": "%{invite_email} will see the invitation in their inbox",
            "danger_title": "Invitation was unsuccessful",
            "danger_description": "Please try again later"
        },
        "email": {
            "invalid_email": "Please enter a valid email address"
        },
        "inviteOthers": "Invite others",
        "searchForSomeone": "Search for someone",
        "searchForOthersToInvite": "Search for others to invite",
        "programNameOnly": {
            "title": "%{programName} only",
            "description": "This %{entityType} is only available to people that are a part of %{programName}"
        },
        "domainCannotBeUsed": "This domain cannot be used with %{programName}",
        "actionSearchByEmail": "Invite by email if you can't find who you are looking for",
        "send": "Send",
        "addEmailToList": "Add email to list",
        "toBeSent": "Invitations to be sent",
        "noInvitationsToBeSent": "No invitations",
        "removeEmailConfirmation": "Are you sure you want to remove this email from list?",
        "yes": "Yes",
        "no": "No",
        "foundByEmail": "We found this person with a matching email",
        "addToFriendsAndFamily": "Add to friends & family",
        "alreadyAddedEmail": "You have already added this email to the list"
    },
    "pointsCurrencyAdditionalInfo": "Your %{points_name} and levels start fresh every %{period}. All of your tracked activities contribute to your overall level in the period.",
    "rankLabel": "Rank",
    "leaderboards": {
        "loadingLabel": "Loading leaderboards... This may take a few minutes - it looks like everyone's out getting active!"
    },
    "feeds": {
        "emptyListHomePage": "There are no posts to show yet. Try adjusting the stream to show more posts.",
        "viewingPostsFrom": "Viewing posts from",
        "postActivity": "Add a comment or photo about your activities!",
        "indicatorLoader": {
            "defaultTitle": "Refreshing...",
            "successfulLoadedTitle": "Synced & refreshed..."
        },
        "inapropriateTextError": {
            "message": "The content in your message may be inappropriate. Please try to use friendlier language."
        },
        "postImageError": {
            "title": "Sorry, we can't post this",
            "message": "The image you've added may be inappropriate. Please try another one."
        }
    },
    "syncModal": {
        "connect": {
            "title": "Connecting %{name}",
            "description": "To connect your %{name} data with your account complete the following steps:",
            "firstStep": "Download and install the %{appName} mobile application from the %{storeName}",
            "fourthStep": "Select to connect with %{name}",
            "fifthStep": "When prompted, select the health metrics to sync with %{appName} and press 'Done'",
            "additionalInfo": "Please note that to trigger sync from the Health app, %{appName} must be opened. While you do not need to keep the app open, it may take an hour for sync to complete and appear in your activity log."
        },
        "title": "Syncing %{name}",
        "description": "To sync your %{name} data with your account complete the following steps:",
        "steps": {
            "one": "Sign in to your %{appName} app on your phone",
            "two": "Open the Apps & Devices section in your profile",
            "three": "Press the sync button next to %{name}",
            "iPhone": "Sign in to your %{appName} app on your iPhone"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "Work account",
            "message": "Account successfully connected"
        },
        "danger": {
            "message": "Error connecting account"
        },
        "conflict": {
            "message": "Account is already linked to a different user"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "Work account",
            "message": "Account successfully disconnected"
        },
        "danger": {
            "title": "Link accounts",
            "message": "Error disconnecting account"
        }
    },
    "earnMoreWithPartners": "Earn more with partners",
    "connectPartnersToEarnByShopping": "Connect your accounts and earn more %{unit_type} by shopping with %{program_name} partners.",
    "viewAllPartners": "View all partners",
    "myPartnerMemberships": "My partner memberships",
    "linkAccount": "Link membership",
    "linkToPartner": "Link to partner",
    "linkingError": "There was a problem linking your account. Please try again.",
    "linkPending": "Link pending",
    "unlinkAccount": "Unlink account",
    "linkedToPartnerName": "Linked to %{partner_name}",
    "linked": "Linked",
    "permission": {
        "facebookTitle": "Sign up with Facebook",
        "googleTitle": "Sign up with Google",
        "facebookDescription": "When signing up with Facebook you will need to grant permission to our technology partner \"Sprout\" to access your identity and create your %{programName} account.",
        "googleDescription": "When signing up with Google you will need to grant permission to our technology partner \"Sprout\" to access your identity and create your %{programName} account.",
        "camera": {
            "title": "Camera access",
            "description": "Camera access is required to take a photo. In iPhone settings, tap %{appName} and turn on Camera.\n\nPlease note that you may lose any unsaved changes."
        },
        "notNow": "Not now",
        "openSettings": "Open settings",
        "photos": {
            "title": "Please allow photo access",
            "description": "This allows you to share photos from your library and save photos to your camera roll. In iPhone settings, tap %{appName} and switch Photos to Read and write.\n\nPlease note that you may lose any unsaved changes."
        }
    },
    "firstNameContainsSpecialChar": "Your first name may only contain English letters, hyphens -, and apostrophes",
    "lastNameContainsSpecialChar": "Your last name may only contain English letters, hyphens -, and apostrophes '",
    "goToPartnerSite": "Go to partner site",
    "noPartnersFound": "No partners found",
    "noLinkedPartners": "No linked partners",
    "noPartnersInCategory": "No partners in category",
    "partnerAccountPendingVerification": "Account verification pending",
    "shopWithPartner": "Shop with partner",
    "shopWithPartnerName": "Shop with %{partner_name}",
    "linkToPartnerName": "Link to %{partner_name}",
    "earnPartnerMembershipIdentifier": "Membership identifier",
    "earnPartnerAccountPendingAddLink": "Your membership is being linked and may take several days to complete.",
    "earnPartnerAccountPendingRemoveLink": "Your membership is being unlinked and may take several days to complete.",
    "linkStatusUpdating": "Link status updating",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "Congrats on adding your first activities! \n\nIf you want, you can add more activities for today and other days. When done with activities today, tap",
            "description2": "on the next screen when you have nothing more to track."
        },
        "listTitle": "Activities tracked on",
        "dots": {
            "tracked": "Activities tracked on this day",
            "added": "Activities have been added and pending submission"
        },
        "trackedActivitiesFor": "Tracked activities for %{date}",
        "activityTracking": "Activity tracking",
        "addedPending": "Added (pending submission)",
        "search": {
            "description1": "Tap",
            "description2": "to see available activities or search for a specific activity"
        },
        "addActivity": "Add activity",
        "addAnotherActivity": "Add another activity"
    },
    "rewardsBalance": "%{currencyName} balance: %{points}",
    "membershipIdentifierRequiredError": "Your membership identifier is required to link",
    "incorrectValueInRange": "Please enter a value between %{min} and %{max}",
    "joinTeam": {
        "title": "Join team",
        "createInsteadText": "Join or create a team to participate in this challenge"
    },
    "teamRank": "Team rank",
    "teamScore": "Team score",
    "appsDevices": {
        "infoText": "You will be asked to authorize our technology partner Sprout Wellness Solutions, Inc. to access your wellbeing data when adding an app or device.",
        "connectModal": {
            "title": "Authorization",
            "paragraph1Part1": "You will be asked to authorize our technology partner",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "to access your wellbeing data.",
            "paragraph2Desc1": "Your authorization allows",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "to securely sync your",
            "paragraph2Desc4": "data with",
            "paragraph2Desc5": ", and helps you earn more %{pointsName}!"
        },
        "statusAlert": {
            "connectMessage": "Connect an app or activity tracking device and make activity syncing and tracking a breeze",
            "connectAction": "Connect an app or device",
            "errorMessage": "Some of your connected apps or devices are unable to sync",
            "warningMessage": "Some of your connected apps or devices may have a connection issue",
            "errorAction": "Fix this error",
            "warningAction": "Fix this warning",
            "syncingError": "",
            "syncingIssue": ""
        },
        "deviceDetails": {
            "warningMessage": "This app or device is having trouble syncing",
            "errorMessage": "This app or device is unable to sync",
            "warningAction": "Dismiss warning",
            "noActivities": "No %{deviceName} activities have synced to %{programName} in the last 7 days. \n\nIt may take up to an hour for activities to show up here after they are tracked with %{deviceName}.\n\nIf you have another app or device connected, and more steps have been tracked by the other app or device, you will see the activity there. Otherwise, try disconnecting and reconnecting %{deviceName}. If you are asked to authenticate or grant permissions, make sure you are enabling activity data and are using the same account to authenticate as the one used to track the activities. Check out the troubleshooting steps for more information.  "
        },
        "troubleshooting": "Troubleshooting",
        "deviceItem": {
            "error": "Connection error",
            "warning": "Connection warning",
            "unableToSync": "Unable to sync"
        },
        "platformDevice": {
            "defaultApp": "Your device's default health app is",
            "continueMore": "Continue to more apps and devices"
        }
    },
    "friendsAndFamily": {
        "learnMore": "Learn more about friends & family",
        "learnModal": {
            "title": "About friends & family",
            "description": "After you add someone to your friends and family, you can choose to share your posts on %{programName} with only them.\n\nYou can also filter posts you see on %{programName} to only the people on your friends and family list if they have posted to everyone or to you.",
            "description_line1": "After you add someone to your friends and family, you can choose to share your posts on %{programName} with only them.",
            "description_line2": "You can also filter posts you see on %{programName} to only the people on your friends and family list if they have posted to everyone or to you.",
            "whatIconsMean": "What the icons mean",
            "canAdd": "Add",
            "added": "Added"
        },
        "searchDescription1": "Search for people to add to your friends and family.",
        "searchDescription2": "Don't see who you are looking for? Invite them to join by email.",
        "friends&Family": "Friends & family",
        "managingTour": {
            "title": "Managing friends & family",
            "body": "If you would like to remove someone from your friends and family, tap the icon"
        },
        "removeOption": "Remove from friends and family",
        "inviteDescription1": "Search for your friends and family.",
        "inviteDescription2": "Don’t see who you are looking for?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "The posts you share with only friends and family will no longer be visible to %{userFirstName}."
        }
    },
    "skipAll": "Skip all",
    "smallMin": "min",
    "eap": {
        "skipModal": {
            "title": "Are you sure?",
            "description": "You can always contact the Employee & Family Assistance Program from your profile when you need it."
        },
        "contact": {
            "whatIsBestNumber": "What is the best number to contact you at?",
            "whatIsBestTime": "What is the best time to contact you?",
            "morning": "Morning",
            "afternoon": "Afternoon",
            "evening": "Evening",
            "additionalDetails": "Additional details about the time\/date when you would like to be contacted",
            "message": "Contact me in the %{weekDay} at %{phoneNumber}. Additional information: %{additional}",
            "description": "Note: We strongly recommend that you choose a time outside of your work hours and opt for a place where you will be able to have a private conversation. Please include your timezone."
        },
        "phoneNumber": {
            "empty": "This field cannot be empty",
            "missingDigits": "Phone number must contain at least 4 digits"
        },
        "myEAP": "My employee and family assistance program"
    },
    "healthSurveySkipAllTitle": "Skip wellbeing survey",
    "healthSurveySkipAllAlert": "Are you sure you would like to skip all remaining questions of the wellbeing survey?",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "Employee and family assistance program",
            "message": "Please provide your phone number and best contact time"
        }
    },
    "allMyChallenges": "My challenges",
    "invitedChallenges": "Invitations",
    "companyChallenges": "Company challenges",
    "completedChallengesEmpty": "It looks like you haven’t completed any challenges yet.",
    "myChallengesEmpty": "It looks like you haven’t joined any challenges yet.",
    "allChallengesEmpty": "There are no challenges.",
    "startsToday": "Starts today",
    "startedDaysAgo": "Started %{dayCount} days ago",
    "startsInDays": "Starts in %{dayCount} days",
    "privacyOn": "Off",
    "privacyOff": "On",
    "dashboard": {
        "viewLeaderboard": "View leaderboard",
        "timePeriodProgress": "Your progress this %{period}",
        "howToEarn": "How to Earn Points"
    },
    "privacyChangeConfirmationMessage": "Change privacy?",
    "privacySettingsTitle": "Privacy",
    "privacySettingsDescription": "You can control the visibility of your picture, name, and profile to other users. ",
    "mainLeaderBoardSettingsTitle": "?Overall leaderboard",
    "challengeLeaderBoardSettingsTitle": "?Challenge leaderboard",
    "managePrivacySettingUrlTitle": "Manage privacy settings",
    "onboardingFamilyPrivacySettingsMessageOn": "You are visible in friends & family search results. You can choose to hide yourself from search results.",
    "onboardingFamilyPrivacySettingsMessageOff": "Your privacy settings currently hide you in friends & family search results.",
    "challengeInvitationPrivacySettingsMessageOn": "You are visible in challenge invitation search results. You can choose to hide yourself from search results.",
    "challengeInvitationPrivacySettingsMessageOff": "Your privacy settings currently hide you from challenge invitation search results.",
    "challengeParticipationPrivacySettingsMessageOn": "You are listed as a participant of this challenge. You can choose to hide yourself as a participant from your challenges.",
    "challengeParticipationPrivacySettingsMessageOff": "Your privacy settings currently hide you from the participant list.",
    "communityInvitationPrivacySettingsMessageOn": "You are visible in community invitation search results. You can choose to hide yourself from search results.",
    "communityInvitationPrivacySettingsMessageOff": "Your privacy settings currently hide you from community invitation search results.",
    "communityParticipationPrivacySettingsMessageOn": "You are listed as a member of this community. You can choose to hide yourself as a member from your communities.",
    "communityParticipationPrivacySettingsMessageOff": "Your privacy settings currently hide you from the member list.",
    "eventInvitationPrivacySettingsMessageOn": "You are visible in event invitation search results. You can choose to hide yourself from search results.",
    "eventInvitationPrivacySettingsMessageOff": "Your privacy settings currently hide you from event invitation search results.",
    "eventParticipationPrivacySettingsMessageOn": "You are listed as an attendee of this event. You can choose to hide yourself as an attendee from your events.",
    "eventParticipationPrivacySettingsMessageOff": "Your privacy settings currently hide you from the attendee list.",
    "mainLeaderboardPrivacySettingsMessageOn": "You are displayed on the overall leaderboards. You can choose to hide yourself, which will remove your rank, picture, and name when others view the overall leaderboards.",
    "mainLeaderboardPrivacySettingsMessageOff": "Your privacy settings currently hide you when others view the overall leaderboards.",
    "challengeLeaderboardPrivacySettingsMessageOn": "You are displayed on challenge leaderboards. You can choose to hide yourself, which will remove your rank, picture, and name when others view challenge leaderboards.",
    "challengeLeaderboardPrivacySettingsMessageOff": "Your privacy settings currently hide you when others view challenge leaderboards.",
    "thumbsUpConfirmationTitle": "Thumbs up",
    "thumbsUpConfirmationDescriptionline1": "Congratulations, you are about to give your first thumbs up and encourage others!",
    "thumbsUpConfirmationDescriptionline2": "You will be included in the list of people who gave thumbs up to this post and others can see your picture, name, and can view your profile.",
    "thumbsUpConfirmationButtonOk": "Thumbs up",
    "commentToActionInfoTitle": "What do others see?",
    "commentToActionMessage": "When you comment others can see your picture, name, and can view your profile.",
    "postToActionTitle": "Who sees this post?",
    "postToActionMessageLine1": "When you create a post, you can control who can see it and even post just to yourself.",
    "postToActionMessageLine2": "The posts you share with others will show your picture, name, and others can view your profile",
    "privateUsersDescriptionChallenge": "These participant(s) have hidden themselves from the list",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n} private",
    "privateUsersLastNamePlaceHolderChallenge": "participant(s)",
    "privateUsersDescriptionEvent": "These attendee(s) have hidden themselves from the list",
    "privateUsersFirstNamePlaceHolderEvent": "%{n} private",
    "privateUsersLastNamePlaceHolderEvent": "attendee(s)",
    "privateUsersDescriptionCommunity": "These member(s) have hidden themselves from the list",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n} private",
    "privateUsersLastNamePlaceHolderCommunity": "member(s)",
    "noPrivacySettings": "No privacy settings",
    "linkToPartnerNameWebsite": "Link via %{partner_name} website",
    "linkToPartnerWebsiteUrl": "Partner website URL",
    "start_end_time": "Start and End time:",
    "joinCreateTeamPrivacyDisclaimer": "Your picture, name, and profile will always be visible to anyone when viewing your team in a challenge, even if you’ve changed your Privacy Settings to Private.",
    "carouselInstructions": {
        "swipe": "Swipe the cards to see all your goals and challenges.",
        "click": "Click the cards to see all your goals and challenges."
    },
    "achieved": "Achieved",
    "hours": "hours",
    "createCommunityFlow": {
        "navigatorTitle": "Create community",
        "stepType": {
            "title": "Community visibility",
            "subTitle": "Who will be able to see and join the community?",
            "privateName": "Private",
            "publicName": "Public",
            "privateDescription": "Only people you invite will be able to see or join the community",
            "publicDescription": "Anyone can see and join this community"
        },
        "stepName": {
            "title": "Name your community",
            "subTitle": "Name your community something that will let people know what it's all about.",
            "namePlaceholder": "Community name",
            "noFieldsTitle": "Name",
            "noFieldsMessage": "No name is given"
        },
        "stepDescription": {
            "title": "About your community",
            "subTitle": "Tell others what your community is all about.",
            "descriptionPlaceholder": "Description (optional)",
            "noFieldsTitle": "Description",
            "noFieldsMessage": "No description is given"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "Add a photo"
        },
        "stepJoin": {
            "title": "We found similar communities",
            "subTitle": "Would you like to join one of these communities instead?"
        },
        "createNew": "Create new community"
    },
    "challengeCard": {
        "allActivities": "All activities in the",
        "category": "category"
    },
    "myLinkedPartners": "My linked partners",
    "leaderboardPosition": "Overall leaderboard position",
    "remainingInChallenge": "remaining in challenge",
    "todays_progress": "Today’s progress",
    "this_weeks_progress": "This week’s progress",
    "this_months_progress": "This month’s progress",
    "achievement": "achievement",
    "challengeCardHeader": {
        "challenge": "Challenge",
        "recommended_personal_goals": "Recommended personal goal",
        "personal_goal": "Personal goal",
        "competition": "Competition",
        "recommended_goals": "Recommended goal",
        "team_competition": "Team competition",
        "team": "Team"
    },
    "MyMedibank": "My Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "The end time cannot be earlier than the start time",
    "company": "Company",
    "lessThan1DayRemain": "less than 1 day",
    "lessThan1HourRemain": "less than 1 hour",
    "remainingToday": "remaining today",
    "periodEndsDateAndTime": "Period ends %{date}, %{time}",
    "moreToGo": "%{n} more %{unit} to go from",
    "reachedYourGoal": "You reached your goal %{period}!",
    "reachedYourGoalToday": "You reached your goal today!",
    "editProfileItemCorrectRange": "Please provide a valid %{itemName} value between minimum value %{min} and maximum value %{max}",
    "invalidUrl": "Invalid URL",
    "activityLogChanged": {
        "success": "Changes to the activity have been saved",
        "info": "Something went wrong... Please, try again.",
        "danger": "Something went wrong... Please, try again."
    },
    "discardAlert": {
        "createChallenge": "Are you sure you want to discard this %{challengeType}?",
        "inviteByEmail": "Are you sure you want to discard the changes?",
        "createTeam": "Are you sure you wish to cancel creation of this team?",
        "cancel": "Cancel",
        "confirm": "Yes, discard"
    },
    "entityInvalidNameError": "Name of the %{entity} should contain only numbers or string value and can not be empty",
    "accept": "Accept",
    "sync_now": "Sync now",
    "reconnect_device": "Reconnect",
    "supported_activities": "Supported activities",
    "recentlySynced_activity": "Recently synced activity",
    "noSyncedActivity_sevenDays": "No activities have been synced in the past 7 days",
    "recentActivityLog": {
        "convertingActivityPoints": "Syncing activities...",
        "activityMinuteOrTwo": "This may take a minute or two...",
        "noNewActivities": "No new activities added... It may take up to an hour for new activities to sync."
    },
    "deleteCommunityCheckbox": "I understand this cannot be undone",
    "createEvent": {
        "type": {
            "company": "Company event",
            "user": "User event",
            "title": "Event type"
        },
        "privacy": "Privacy (show attendees or not)",
        "cost": "Cost",
        "associated": {
            "location": "Associated Location",
            "department": "Associated Department \/ division"
        },
        "maxParticipants": "Max. Participants (optional)",
        "errorMessage": {
            "limit": "Cannot be greater than %{maxValue}",
            "negative": "Cannot be a negative value",
            "selectedLocations": "Please select one or more locations"
        },
        "selectLocations": "Selected locations",
        "createNew": "Create new event"
    },
    "selected": "Selected",
    "deleteEventButton": "Delete this event",
    "notification": {
        "priorityNotification": {
            "title": "You have unread important updates",
            "subtitle": "Tap to read them now",
            "subtitleWeb": "Click to read them now"
        },
        "sectionTitle": {
            "priorityUnread": "Unread important updates",
            "all": "All notifications"
        },
        "modalTitle": "You have %{count} important updates",
        "priorityModalTitle": {
            "defaultTitle": "View All Updates"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "Cancel %{entity} %{actionType}",
            "message": "Are you sure you want to cancel %{entity} %{actionType}?"
        },
        "action": {
            "creating": "creating",
            "editing": "editing"
        },
        "type": {
            "team": "team",
            "community": "community",
            "event": "event",
            "challenge": "challenge",
            "goal": "goal"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "Make it public?",
            "private": "Make it private?"
        },
        "modalSubtitle": {
            "public": "Making this %{entityType} public will open it to everyone to discover and join. Are you sure you want to make this %{entityType} public?",
            "private": "Making this %{entityType} private will close it to nobody to discover and join. Are you sure you want to make this %{entityType} public?"
        },
        "footerButton": {
            "makePublic": "Yes, make it public",
            "makePrivate": "Yes, make it private",
            "keepPrivate": "Keep private",
            "keepPublic": "Keep public"
        },
        "label": {
            "title": "Make this a public %{entityType}",
            "subtitle": "Everyone can see, and anyone can join"
        }
    },
    "imageUploader": {
        "changeImageButton": "Change Image"
    },
    "copyright": "Copyright © Sprout 2019",
    "samsunghealth_not_available": "Unable to connect with Samsung Health. In the Health app, under Data Permissions, ensure you have at minimum enabled permission to steps and have a least 1 step tracked.",
    "rewardsHowDoIEarn": "How do I earn %{currencyName}?",
    "unlockAchievements": "Unlock achievements",
    "unlockAchievementsDescription": "Track activities, earn %{pointsName}, unlock levels and earn more %{currencyName}. Tap on each achievement to see what you need to do.",
    "myDay": "My day",
    "myGoalsChallengesTasks": "My goals, challenges, and tasks",
    "yourGoalsChallenges": "Your goals and challenges",
    "mySocialStream": "Community posts",
    "viewAllAchievements": "View all achievements",
    "viewAllBonusChallenges": "View all bonus challenges",
    "newVersionOfAppAvailable": "New version available! Please reload this page",
    "noBonusChallengesToDisplay": "There are currently no bonus challenges available.",
    "bonusChallenges": "Bonus challenges",
    "reloadAppVersion": "Reload",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "Are you sure you want to remove tracking %{activity_name}?",
    "activity_tracker_instruction_header": "Tap on a day to track activities for that day, or see what was already tracked.",
    "alertDashboardFunctionalityToBeAdded": "text will be added here to explain what a tracking period is, similar to how it is done for airline loyalty programs where users need to keep accumulating “miles” in a calendar year to get status for next year.",
    "noNumberEntered": "Enter the amount of activity",
    "feed": "Stream",
    "home": "Home",
    "challenges": "Challenges",
    "explore": "Explore",
    "rewards": "Rewards",
    "reward": "reward",
    "balance": "My %{programName} rewards balance",
    "profile": "Profile",
    "loading": "Loading...",
    "me": "Me",
    "back": "Back",
    "next": "Next",
    "skip": "Skip",
    "signup": "Sign up",
    "signin": "Log in",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "Log in to Live Better",
    "signup_with_medibank": "Sign up as a Medibank member",
    "signup_with_facebook": "Sign up with Facebook",
    "signup_with_google": "Sign up with Google",
    "signup_with_email": "Sign up with email",
    "signin_with_medibank": "Log in using My Medibank",
    "signin_with_facebook": "Log in with Facebook",
    "signin_with_google": "Log in with Google",
    "signin_with_email": "Log in with email",
    "signup_heading": "Create account",
    "not_a_medibank_member": "Not a Medibank member?",
    "keep_me_signed_in": "Keep me logged in",
    "forgotpassword": "Forgot your password?",
    "emailaddress": "Email address",
    "password": "Password",
    "enterEmailAddress": "Enter your email address",
    "enterYourPassword": "Enter your password",
    "password_for_error": "password",
    "reset_password": "Reset password",
    "passwordResetSuccess": "Password reset",
    "passwordResetEmailSent": "If we have a matching email in our system then password reset instructions have been emailed to you.",
    "loginerror": "An error has occurred while logging in:",
    "logincancelled": "Log in cancelled",
    "part_of_corporate_program": "Are you signing up to a corporate program?",
    "continue_here": "Continue here",
    "program_name": "Program name",
    "error_provide_program_name": "Please provide a program name.",
    "program_not_found": "Program not found",
    "registration_field_email": "Email",
    "employeeId": "Employee ID",
    "registration_field_firstName": "First name",
    "registration_field_lastName": "Last name",
    "no_first_name": "No first name",
    "no_last_name": "No last name",
    "registration_field_password": "New password",
    "no_disclaimer_available": "Oops, there's been a problem... We couldn't retrieve your organization's terms and conditions. Please try registering again later. ",
    "registration_account_not_registered": "It looks like you haven't verified your email address yet. Would you like us to resend the email?",
    "resend_verification_email": "Email verification",
    "resend_verification_email_successful": "We've resent your verification email.",
    "resend_verification_email_unsuccessful": "Oops, there's been a problem... we weren't able to resend the verification email. Please try again.",
    "not_supported": "This post can't be displayed right now. Please try again later.",
    "policyAgreeError": "To continue, please agree to the Terms of Service and Privacy Policy.",
    "challenge_completion_bonus": "Completion bonus",
    "me_tabs": {
        "activity": "Activity",
        "bookmarks": "Bookmarks"
    },
    "health_tab": {
        "my_health_score": "Your wellbeing score",
        "overall_health_score_description": "Your wellbeing score is",
        "health_score_explanation": "Your wellbeing score is calculated from your answers about your health and how active you are. \n\nYour score gets updated every month based on your activity levels. You can set and complete personal goals to improve your wellbeing score.",
        "health_score_calculation_failed_onboarding": "Something went wrong and we haven't been able to retrieve your wellbeing score. You can proceed for now and as soon as the problem's fixed, we'll update your score."
    },
    "track_activity": "Track activity",
    "track_an_activity": "Track an activity",
    "track": "Track",
    "unable_to_track": "Unable to track",
    "enter_before_track": "Enter the amount of activity to track",
    "what_to_share": "What kind of update would you like to share?",
    "remove": "Remove",
    "activity_tracking_description": "How many %{units} would you like to track?",
    "excessive_submission": "Wow! You're about to track over 2,000 %{customPoints} for %{activity_name}. You might want to make sure that's right before you submit it.",
    "on": "on",
    "in": "in",
    "from": "from",
    "at": "at",
    "no_activities": "No activities matched your search.",
    "activity_tracking_desc": "You need to add a number to continue. Tap X in the left corner to cancel.",
    "activity_tracking_desc2": "Tap anywhere on activity to edit, tap + to quick track for the goal",
    "vital_stats_title": "About you",
    "invalid_numeric_response": "Invalid",
    "invalid_numeric_response_range": "This number must be between %{minimum} and %{maximum}",
    "search_placeholder": "Search the library...",
    "search_activities": "Search activities",
    "searching": "Searching...",
    "searchEmpty": "No matches found",
    "vital_stats_description": "Tell us a little about yourself",
    "health_survey_questions": "Wellbeing survey questions",
    "health_survey_title": "Complete wellbeing survey",
    "health_survey_results": "Wellbeing survey results",
    "health_survey_card_desc": "Take the survey to get a snapshot of your wellbeing and set personalized goals.",
    "apps_devices_title": "Link apps and devices",
    "apps_devices_card_desc": "Sync your apps and devices to make earning %{customPoints} a breeze.",
    "interests_title": "Interests",
    "interests_card_desc": "Tell us about your interests. This will help us recommend goals and communities that may be of interest to you.",
    "interests_screen_desc": "What are you interested in?",
    "health_obj_title": "Wellbeing objectives",
    "health_obj_card_desc": "We think it's time to set some goals. Once we know your objectives, we'll be able to make better recommendations for you. Don't worry, if you change your mind you can easily make changes later in your profile. ",
    "health_obj_screen_desc": "What areas would you like to work on?",
    "my_heatlh_obj": "My wellbeing objectives",
    "health_topic_title": "Wellbeing topics",
    "health_topic_card_desc": "Personalize your experience by specifying your wellbeing topics.",
    "health_topic_screen_desc": "What are you interested in learning about?",
    "multi_select_check_error": "Please select at least 1 option to proceed",
    "my_health_topics": "My wellbeing topics",
    "build_your_profile": "Build your profile",
    "personalize_title": "Personalize",
    "personalize_desc": "Personalize your experience by answering a few quick questions.",
    "set_goals_title": "See recommended goals",
    "set_goals_desc": "Set personalized goals to get started on your path to better health.",
    "set_this_goal": "Set this goal",
    "goal_set": "Goal set",
    "required": "Required",
    "apps_devices_description": "Connect to a fitness platform to earn more %{customPoints} automatically.",
    "connected": "Connected",
    "num_connected": "(%{numDevices} connected)",
    "available": "Available",
    "inProgress": "In progress...",
    "time_a_m": "am",
    "time_p_m": "pm",
    "last_synced": "Last synced",
    "last_synced_lc": "last synced",
    "no_connected_devices": "No connected devices",
    "apps_devices_confirm_disconnect": "Are you sure you want to disconnect",
    "button_delete": "Delete",
    "button_disconnect": "Disconnect",
    "button_cancel": "Cancel",
    "button_dismiss": "Dismiss",
    "ok": "OK",
    "waist_helper_text": "Your waist measurement should be taken below the ribs, usually at the level of the navel, and while standing. If unsure use your jeans size.",
    "apps_devices_manage": "Manage my apps and devices",
    "my_apps_devices": "My apps and devices",
    "completeRegistration": "Complete registration",
    "havingTrouble": "Having trouble?",
    "contactUs": "Contact support@sproutatwork.com for assistance",
    "done": "Done",
    "brand": "Sprout",
    "cannotTrackTitle": "Unable to track activity",
    "cannotTrackPrior": "Whoa there. Activities can be tracked only after the start date.",
    "cannotTrackFuture": "Not so fast. Activities can be tracked only up to the current day.",
    "cannotTrack": "Activities can't be tracked before a start date, or for a day in the future.",
    "disclaimer": "Disclaimer",
    "acceptTerms": "I accept the terms and conditions",
    "verificationEmailTitle": "Verify your email",
    "email_not_yet_verified": "It looks like you haven't verified your email address yet. ",
    "email_successfully_verified_title": "Welcome",
    "email_successfully_verified": "You've successfully verified your email",
    "pleaseVerifyEmailMessage1": "You'll need to verify your email address to continue.",
    "pleaseVerifyEmailMessage2": "Please follow the instructions sent to:",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "Resend email",
    "restart": "Back to login",
    "firstName": "First name",
    "firstNamePlaceholder": "Your first name",
    "lastName": "Last name",
    "lastNamePlaceholder": "Your last name",
    "email": "Email",
    "emailPlaceholder": "Your email address",
    "employeId": "Employee ID",
    "employeIdPlaceholder": "Company employee ID",
    "passwordPlaceholder": "New password",
    "datePickerTitle": "Select your date of birth",
    "datePickerConfirm": "Confirm",
    "datePickerCancel": "Cancel",
    "termsOfUsePrivacyPreLinks": "I agree to the",
    "sendMePromoCommunications": "Send me promotional communications",
    "sendMePromoCommunicationsFromPartners": "Send me promotional communications from partners",
    "termsOfService": "Terms of Service",
    "legal": "Legal",
    "privacyPolicy": "Privacy Policy",
    "and": "and",
    "programDomainLabel": "Program name",
    "programDomainPlaceholder": "Program name",
    "findProgramName": "Find my program name",
    "findProgramNameButton": "Find program name",
    "findProgramNameTitle": "Find my program name",
    "findProgramNameDescription": "Company email address",
    "findProgramNamePlaceholder": "Email address",
    "findProgramSuccessMessage": "Results of the program name search have been emailed to you.",
    "findProgramSuccessTitle": "Program name",
    "findProgramErrorTitle": "Program name",
    "findProgramErrorMessage": "Oops, there's been a problem... We encountered an error while trying to retrieve your program name. Please try again.",
    "countryLabel": "Select country",
    "countryName": "Country",
    "regionLabel": "Select region",
    "regionName": "Region",
    "cityLabel": "Select city",
    "cityName": "City",
    "locationWorkLabel": "Select location",
    "locationWorkName": "Location",
    "locationLabel": "Select location",
    "locationName": "Location",
    "departmentLabel": "Select department \/ division",
    "departmentName": "Department \/ division",
    "no_department": "No department \/ division",
    "enterPIN": "Please enter your company PIN",
    "verifyEmailTitle": "Email verification",
    "verifyEmailMsg": "It looks like you haven't verified your email address yet",
    "resendEmailTitle": "Email verification",
    "resendEmailMsg": "Resent to %{userEmail}",
    "select_date": "Select a date",
    "changePasswordTitle": "Change password",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "confirmNewPassword": "Confirm new password",
    "passwordChangeError": {
        "currentPasswordMissing": "Enter your current password",
        "newPasswordMissing": "Enter your new password",
        "confirmPasswordMissing": "Confirm your new password",
        "passwordsMatch": "Passwords do not match",
        "passwordIncorrect": "Incorrect password. Please try again."
    },
    "settings": "Settings",
    "signOut": "Sign out",
    "updateApp": "Update app",
    "updateAppRight": "Current: %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "Get help",
    "feedback": "Feedback",
    "feedback_success_title": "Feedback submitted",
    "feedback_success_msg": "Thank you for submitting your feedback, we really appreciate it!",
    "feedback_failure_title": "Error",
    "feedback_failure_msg": "Bummer... There was an error submitting your feedback, please try again.",
    "submit": "Submit",
    "feedback_char_limit": "You have exceeded the character limit.",
    "feedback_char_limit_toast_title": "Message too long",
    "feedback_char_limit_toast_msg": "Your message exceeds the maximum 2000 character limit.",
    "feedback_char_length_msg_1": "You have typed",
    "feedback_char_length_msg_2": "\/2000 characters.",
    "feedback_empty_toast_title": "Message empty",
    "feedback_empty_toast_msg": "It looks like you haven't typed anything yet. Type a message before submitting.",
    "feedback_email_message": "Message:",
    "feedback_email_user_id": ", User ID:",
    "feedback_email_device": ", Device:",
    "feedback_email_os_version": ", OS Version:",
    "feedback_email_app_version": ", App Version:",
    "savingUserToast": {
        "success": {
            "title": "Save changes",
            "message": "Profile changes saved"
        },
        "danger": {
            "title": "Error encountered",
            "message": "Oops... We encountered an error trying to save your changes, please try again."
        }
    },
    "edit_profile_user_error_msg": "Please review errors before trying to save your changes",
    "edit_profile_location_error": "You need to specify your location",
    "edit_profile_department_error": "You need to specify your department \/ division",
    "edit_profile_unspecified_value": "You need to specify a value",
    "edit_profile_value_too_low": "The value must be more than",
    "edit_profile_value_too_high": "The value must be less than",
    "choose_gender": "Select sex",
    "activity_tracked_successfuly": "Your activity is being tracked",
    "multi_activity_tracked_successfully": "Your activities are being tracked",
    "no_activities_tracked": "No activities tracked",
    "track_activity_to_submit": "Choose a date on the calendar to track an activity",
    "last_day": "Last",
    "days_remaining": "days remaining",
    "day_remaining": "day remaining",
    "days_remaining_this_week": "days remaining this week",
    "day_remaining_this_week": "day remaining this week",
    "days_remaining_this_month": "days remaining this month",
    "day_remaining_this_month": "day remaining this month",
    "earned_today": "Earned today",
    "earned_this_week": "Earned this week",
    "earned_this_month": "Earned this month",
    "earned_in_total": "Earned in total",
    "goal_completed": "Goal completed,",
    "see_results": "see results",
    "pts": "%{customPoints}",
    "of": "of",
    "daily_goal": "Daily goal",
    "weekly_goal": "Weekly goal",
    "monthly_goal": "Monthly goal",
    "total_goal": "Total goal",
    "weeks": "weeks",
    "today": "Today",
    "this_week": "This week",
    "this_month": "This month",
    "overall": "Overall",
    "level": "Level",
    "days_remaining_in_period": "%{remainingDays} days remaining",
    "days_left_in_period": "%{remainingDays} days left to track",
    "pointsToLevel": "Progress towards %{levelName}",
    "levelCompleted": "%{levelName} completed",
    "keepTrackingUntil": "Keep tracking until",
    "activityLevelTitle": "My activity level",
    "activityLevelDescription": "How much time do you spend being at least moderately active - that is when you're working hard enough to raise your heart rate and break a sweat - in a typical week? ",
    "activityLevelUnder60": "Under 60 minutes",
    "activityLevelUnder150": "60 to 150 minutes",
    "activityLevelOver150": "Over 150 minutes",
    "gender_male": "Male",
    "gender_female": "Female",
    "gender_rather_not_say": "Rather not say",
    "date_of_birth": "Date of birth",
    "height": "Height",
    "Height": "Height",
    "weight": "Weight",
    "waistCircumference": "Waist circumference",
    "bloodPressureHg": "Blood pressure systolic",
    "bloodPressureMm": "Blood pressure diastolic",
    "bloodCholesterol": "Total blood cholesterol",
    "ldl": "Low density lipoprotein (LDL)",
    "hdl": "High density lipoprotein (HDL)",
    "restingHeartRate": "Resting heart rate",
    "percentageBodyFat": "Percentage body fat",
    "hipCircumference": "Hip circumference",
    "bloodGlucose": "Blood Glucose",
    "triglycerides": "Triglycerides",
    "error_401_signed_out_message": "Your session has expired. Please log in again.",
    "first_name": "First name",
    "last_name": "Last name",
    "preferred_name": "Preferred name",
    "notifications": "Notifications",
    "notificationsMarkAllReadButton": "Mark all notifications as read",
    "notificationsSettingsButton": "Settings",
    "notificationsSettingsTitle": "Notifications & emails",
    "notificationEmptyMessage": "You're up to date with your notifications",
    "priorityModalTitle": "My priority notifications",
    "remindMeLater": "Remind me later",
    "priorityAdminTitle": "Notification from your administrator",
    "markAsRead": "Mark as read",
    "expand": "Tap to expand",
    "collapse": "Tap to collapse",
    "takePhoto": "Take a new photo",
    "choosePhoto": "Choose a photo",
    "deletePhoto": "Delete photo",
    "profileImageChangeErrorTitle": "Error encountered",
    "profileImageChangeErrorMessage": "Oops... Something went wrong with editing your photo. Please try again.",
    "editProfile": "Edit profile",
    "postButton": "Post",
    "shareYourDayName": "What are you up to?",
    "greeting": "Hello, %{firstNameDisplay}!",
    "shareAnUpdate": "What are you up to?",
    "shareYourDaySubtitle": "What are you up to?",
    "shareAPost": "Share a post",
    "postVisibleTo": "Visible to",
    "link": "Link",
    "photo": "Photo",
    "insertLink": "Add a link to your post",
    "save": "Save",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "You need to add content to your post before submitting.",
    "generalErrorTitle": "Post empty",
    "generalSuccessTitle": "Success",
    "simplePlaceholder": "What are you up to?",
    "likesCountLabel": "Thumbs up",
    "likesReceivedLabel": "Thumbs up received",
    "commentsCountLabel": "Comments",
    "commentsCountLabelSingular": "Comment",
    "likeButton": "Thumbs up",
    "commentButton": "Comment",
    "seePreviousComments": "See previous comments",
    "addCommentPlaceholder": "Add a comment",
    "postCommentButton": "Post",
    "seeMoreLongComment": "See more",
    "activityPoints": "%{customPoints}",
    "activityLog": "Activity log",
    "discardPost": "Discard",
    "discardPostMessage": "Are you sure you want to discard your post?",
    "stream_filter_title": "Stream",
    "stream_filter_screen_desc": "Select the posts you'd like to view in the stream",
    "stream_filter_selection": "Showing:",
    "moderate": "Mark as inappropriate",
    "moderateDescription": "Marking this item as inappropriate will remove it and an administrator will be notified.",
    "editPost": "Edit post",
    "deletePost": "Delete post",
    "deleteComment": "Delete comment",
    "editComment": "Edit comment",
    "visibleOnlyToMe": "Visible only to me",
    "joinEvent": "RSVP for event",
    "joinEventDetail": "Join event",
    "joinedEvent": "I'm going",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "You have joined the event",
            "message": "You've successfully joined  this event"
        }
    },
    "joinChallenge": "Join challenge",
    "viewChallenge": "View challenge",
    "joinedChallenge": "Joined challenge",
    "joinCommunity": "Join community",
    "joinedCommunity": "Joined community",
    "joinProgress": "Joining",
    "joinSuccess": "Joined",
    "invitePeopleToCommunity": "Invite people to community",
    "numberOfMembers": "%{num} members",
    "joinToView": "Join this community to view and post to other members",
    "numberOfAttendees": "%{num} attendee(s)",
    "numberOfParticipants": "%{num} participants",
    "numberOfMembersWithUser": "You and %{num} other member(s)",
    "numberOfAttendeesWithUser": "You and %{num} other attendee(s)",
    "numberOfParticipantsWithUser": "You and %{num} other participant(s)",
    "communityMembers": "%{numberOfMembers} member(s)",
    "communityEvents": "%{numberOfEvents} upcoming event",
    "myEvents": "My events",
    "seeAll": "See all",
    "noUpcomingEvents": "No upcoming events. Let's join one!",
    "myCommunities": "My communities",
    "invitedCommunities": "Invited",
    "invitationSendingMessage": "Sending invites...",
    "invitationReceivedMessage": "invited you to join this",
    "invitationMessage": "We'd love to have you in our community!",
    "recommendedCommunities": "Recommended for you",
    "leaveCommunity": "Leave this community",
    "leaveTeam": "Are you sure you want to leave team",
    "leaveTeamLastMember": "in this challenge? As the last member of the team, leaving the challenge will delete the team.",
    "leaveTeamChallenge": "in this challenge?",
    "Oops": "Oops something went wrong",
    "editCommunity": "Edit community",
    "deleteCommunity": "Delete this community",
    "leaveCommunityDescription": "Are you sure you want to leave this community?",
    "inviteToCommunity": "Invite to community",
    "inviteByMembers": "Invite by name",
    "inviteByEmail": "Invite by email",
    "select_person": "Please select at least one person to invite",
    "no_users_found": "Hmm… we can't seem to find anyone by that name.",
    "promptJoinCommunities": "It looks like you haven't joined any communities. Join communities to engage with others and share your journey.",
    "exploreCommunities": "Explore communities",
    "sendInviteByMembers": "Invite %{num} people",
    "sendInviteByEmail": "Send email invitation",
    "createNewCommunity": "Create a new community",
    "createCommunity": "Create community",
    "uploadCover": "Add a photo",
    "cover": "Cover",
    "nameOfCommunity": "Community name",
    "whatCommunityAbout": "What is this community about?",
    "companyMembersOnly": "Company members only",
    "viewAllButton": "View all",
    "communities": "Communities",
    "contentLibrary": "Library",
    "events": "Events",
    "past_events": "Past events",
    "invitationCommunity": "community",
    "searchPeople": "Search people",
    "enterEmail": "Enter email",
    "personalMessageToNewInvitees": "Personal message to new invitees",
    "dangerToastTitle": "Error",
    "dangerToastMessage": "Hmm... Something went wrong. Please try again.",
    "successToastTitle": "Success",
    "successToastMessage": "Action completed",
    "joiningToast": {
        "success": {
            "message": "You joined"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "Comment deleted"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "Comment marked as inappropriate"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "Comment updated"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "Comment updated"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "Profile photo updated"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "Photo photo deleted"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "Post to stream",
            "message": "Your post has been created"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "Edit post",
            "message": "Your post has been edited"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "Delete post",
            "message": "Your post has been deleted"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "Mark inappropriate",
            "message": "Post marked as inappropriate"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "Mark as read",
            "message": "All notifications marked as read"
        },
        "info": {
            "title": "Mark as read",
            "message": "All notifications have already been marked as read."
        },
        "danger": {
            "title": "Mark as read"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "Unable to mark the notification as read"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "Password updated",
            "message": "Sign in with your new password"
        },
        "danger": {
            "title": "Update password",
            "message": "Oops… Something went wrong when we tried to update your password. Please try again."
        }
    },
    "joining": {
        "success": {
            "message": "You joined %{name}"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "Invitations",
            "message": "Invitation(s) have been sent"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "Create community",
            "message": "Your new community has been created"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "Your goal has been restarted"
        },
        "danger": {
            "message": "Unable to restart goal"
        }
    },
    "quit": "Quit",
    "wellbeing_survey_completed": "Wellbeing survey completed",
    "wellbeing_survey_completed_message": "Thank you for completing the survey. We hope that this has helped you gain some insight into your wellbeing.",
    "update_wellbeing_score": "Update my survey answers",
    "get_wellbeing_score": "Get your wellbeing score",
    "stats": "Stats",
    "my_wellbeing_score": "My wellbeing score",
    "see_details": "See details",
    "how_score_calculated": "How is my score calculated?",
    "contentTitle": "Library",
    "promoted": "Featured",
    "recommended": "Recommended",
    "recommendedForMe": "Recommended for me",
    "recent": "Recently added",
    "view": "View",
    "added": "Added",
    "more": "more",
    "openLibrary": "Take me to the library",
    "readToEarn": "Read to earn",
    "readArticle": "Open link",
    "see_more": "See more (%{num})",
    "see_more_activities": "%{num} more",
    "my_achievements": "My achievements",
    "achievements": "Achievements",
    "achievement_earned_date": "Earned: %{date}",
    "achievement_start_date": "Started: %{date}",
    "achievement_end_date": "Ends: %{date}",
    "achievement_earned": "Earned",
    "achievement_start": "Starts",
    "achievement_end": "Ends",
    "achievement_earned_times": "%{num} times",
    "achievement_earned_time": "%{num} time",
    "in_progress": "In progress",
    "date_earned": "Date earned",
    "earned": "Earned",
    "past_dates_earned_heading": "Past dates earned",
    "all": "All",
    "eat": "Eat",
    "move": "Move",
    "feel": "Feel",
    "profile_completion": "Profile completion: %{percentage}%",
    "complete_my_profile": "Complete your profile",
    "do_following_tasks": "Do the following %{num} task(s) to complete your profile.",
    "improve_my_score": "Improve your score",
    "see_which_goals": "Check out the goals you've set towards eating, moving and feeling better.",
    "havent_set_goal": "You haven't set a goal yet.",
    "set_a_goal": "Set a goal",
    "set_another_goal": "Set another goal",
    "set_another_goal_here": "Set another goal here.",
    "my_recently_tracked_activities": "My recent activities",
    "a_few_seconds_ago": "a few seconds ago",
    "a_day_ago": "a day ago",
    "yesterday": "Yesterday",
    "earn": "Earn",
    "delete_activity_confirmation": "Are you sure you want to remove this activity?",
    "delete_activity_title": "Remove %{measurement} of %{activity_name}?",
    "reached_daily_goal": "You achieved your goal today. Well done!",
    "multiple_activity_non_daily_instruction": "Tap on an activity row to start tracking and earn %{customPoints}!",
    "multiple_activity_daily_instruction": "Tap on the plus sign to track the amount of an activity needed to reach your goal. Tap anywhere else on the activity row to track any amount of that activity.",
    "only_automatic_activities": "The activities that contribute to this goal can only be tracked automatically",
    "only_automatic_activity": "The activity that contributes to this goal can only be tracked automatically",
    "earn_pts_and_reach_goal": "Earn %{pts} pts and reach your goal by tracking %{qty}",
    "earn_pts_for_every": "Earn %{pts} pts for every",
    "you_track": "you track!",
    "you_have_tracked": "You have tracked %{qty}",
    "so_far": "so far!",
    "start_goal": "Set this goal",
    "about_this_goal": "About this goal",
    "start_date": "Start date",
    "end_date": "End date",
    "activities": "Activities",
    "goal": "Goal",
    "instructions": "Instructions",
    "daily": "Daily",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "total": "Total",
    "week": "Week",
    "day": "Day",
    "days": "Days",
    "month": "Month",
    "months": "Months",
    "progress": "Progress",
    "about": "About",
    "days_remaining_to_track": "You have %{num} days to track any missed activity",
    "number_days": "%{num} days",
    "one_day": "1 day",
    "points_earned_this_week": "Points earned this week",
    "points_earned_year": "Points earned year to date",
    "completed": "Completed",
    "what_you_need_to_do": "What you need to do",
    "see_all_num": "See all %{num}",
    "my_week_progress": "Your weekly progress",
    "my_day_progress": "Your daily progress",
    "my_month_progress": "Your monthly progress",
    "my_total_progress": "Your total progress",
    "my_overall_progress": "Overall progress",
    "you_earned": "You've earned",
    "of_this_week": "of %{num} this week",
    "of_this_day": "of %{num} today",
    "of_this_month": "of %{num} this month",
    "of_this_total": "of %{num} in total",
    "of_this_overall": "of %{num} overall",
    "remaining_this_week": "remaining this week",
    "remaining_this_month": "remaining this month",
    "remaining_this_total": "remaining",
    "remaining_this_overall": "remaining overall",
    "view_history": "View history",
    "this_goal_is": "This goal is",
    "will_run_for": "Will run for",
    "button_unset_goal": "Unset goal",
    "button_leave_challenge": "Leave challenge",
    "leaveChallenge": {
        "menu": "Leave %{challengeName}"
    },
    "deleteChallenge": {
        "menu": "Delete %{challengeName}"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "You have unset this personal goal."
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "You have left the challenge."
        }
    },
    "activities_tracked": "Activities tracked",
    "recently_tracked_activities": "Recently tracked activities",
    "add": "Add",
    "change_before_track": "It looks like you haven't made any changes. Edit the quantity of activity for this day or exit without making changes.",
    "havent_tracked_today": "It looks like you haven't tracked any activity for this day yet. Start by searching for an activity.",
    "cancel_tracking_quantity": "Cancel tracking %{quantity} of %{activity_name}",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "Exiting will discard edits to your activity history. Are you sure?",
    "discard_activity_edits_confirmation_date": "Exiting will discard edits to your activity history for %{date}. Are you sure?",
    "yes_discard_edits": "Yes, exit and discard edits",
    "createGoal": {
        "navigatorTitle": "Create personal goal",
        "navigatorSubtitle": "Step %{step} of 4"
    },
    "allCommunities": "Everything",
    "deleteCommunityDescription": "Are you sure you want to delete this community?",
    "remaining": "remaining",
    "recommended_goal": "Recommended goal",
    "pinError": "PIN %{pin} is not valid. Please try again.",
    "previousPersonalGoals": "My completed personal goals",
    "previousGoalsTitle": "My previous goals",
    "endedOn": "ended on",
    "achievedOfGoal": "You achieved %{num}% of the goal",
    "previousGoalsEmptyMessage": "You have no previous goals",
    "emptyListDefaultMessage": "You have no items here",
    "myCommunitiesEmpty": "It looks like you haven't joined any communities. Join communities to engage with others and share your journey.",
    "discoverMoreCommunities": "Discover more communities",
    "howLong": "Duration",
    "frequency": "Frequency",
    "discard": "Discard",
    "description": "Description",
    "optional": "optional",
    "instruction": "Instruction",
    "name": "Name",
    "create": "Create",
    "categories": "Categories",
    "uploadPhoto": "Add a photo",
    "delete_goal": "Delete this %{name}",
    "delete_goal_confirmation": "Are you sure you want to delete this goal?",
    "leave_goal_confirmation": "Are you sure you want to leave this challenge?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "Your goal has been created."
        }
    },
    "defaultSelectMessage": "Please select an option",
    "search": "Search",
    "inTotal": "in total",
    "State": "State",
    "Business unit": "Business unit",
    "Work location": "Work location",
    "whenStart": "When do you want to start?",
    "every": "every",
    "acceptChallenge": "Accept challenge",
    "activity_history_challenge": "Activity history for challenge",
    "havent_tracked_challenge": "You haven't tracked any activities for this challenge",
    "earned_lowercase": "earned",
    "noone_tracked_yet": "No one has tracked anything yet. Start tracking to be in the lead in this competition!",
    "you": "You",
    "your_team": "My team",
    "congrats_first_place": "Congratulations you're in first place! Keep up the good work.",
    "leader": "Leader",
    "average": "Average",
    "show_leader": "Show leader",
    "show_me": "Show me",
    "show_my_team": "Show my team",
    "leaderboard": "Leaderboard",
    "my_team": "My team",
    "remaining_to_track": "remaining to track",
    "avg": "avg",
    "invite": "Invite",
    "team_members": "Team members",
    "daysLeft": "Days left",
    "regionNameLiveBetter": "State",
    "locationNameLiveBetter": "Work location",
    "departmentNameLiveBetter": "Business unit",
    "regionLabelLiveBetter": "Select state",
    "locationLabelLiveBetter": "Select work location",
    "departmentLabelLiveBetter": "Select business unit",
    "companyLocation": "Work location",
    "no_location": "No location",
    "connect": "Connect",
    "syncing": "Syncing",
    "sync": "Sync",
    "havent_tracked_in_a_while": "No recently tracked activities",
    "contact": "Contact",
    "manage": "Manage",
    "creator": "Creator",
    "allow_notifications": "Manage notifications",
    "enable_notifications": "Turn on notifications",
    "appload": "Hold on just a moment while {app_name} is updated...",
    "sendResetEmail": "Send reset email",
    "min": "Min",
    "max": "Max",
    "error_joining_team": "Unable to join team",
    "cannot_add_to_team": "Oops… Something went wrong when we tried to add you to this team. It may be that the team has reached its maximum number of members or no longer exists. In case another error occurred, please try again.",
    "members_needed": "%{num} members needed",
    "member_needed": "%{num} member needed",
    "spots_left": "%{num} spots left",
    "join": "Join",
    "no_teams_create": "There currently aren't any teams for you to join. Why don't you create one?",
    "number_teams": "%{num} teams",
    "youLowercase": "you",
    "joined_challenge_on_team": "You have joined a challenge on team %{team_name}.",
    "join_team": "Join a team",
    "former_members": "Former members",
    "letsGo": "Let's go",
    "invite_to_team": "Invite to team",
    "connectingDeviceToast": {
        "success": {
            "title": "Connect an app or device",
            "message": "Success! Your app or device is connected."
        },
        "danger": {
            "title": "Connect an app or device",
            "message": "Oops… We had a problem connecting this service. Please try again."
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "Disconnect an app or device",
            "message": "You have successfully disconnected %{name}."
        },
        "danger": {
            "title": "Disconnect an app or device",
            "message": "Oops… We had a problem disconnecting %{name}. Please try again."
        }
    },
    "leave_entity_question": "Leave %{name}?",
    "delete_entity_question": "Delete %{name}?",
    "leave_team_challenge_confirmation": "Are you sure you want to leave %{name} in this challenge?",
    "leave_last_team_member": "As the last member of the team, leaving this challenge will delete the team.",
    "oops_msg": "Oops... There was an error trying to complete this action. Please try again.",
    "has_been_created": "You have joined the challenge on team %{name}.",
    "specify_team_name": "Please specify a team name",
    "invite_members": "Invite members",
    "upload_photo_no_question": "Add a photo",
    "my_progress": "My progress",
    "rewardsPointsAdditionalInfo": "Earn %{reward_currency} for every level reached every %{period}. Your %{customPoints} and levels start fresh every %{period} so you have the opportunity to continue earning %{reward_currency} even if you reached the highest level last period.",
    "rewardsPointsInfo": "Your %{customPoints} and progress reset each %{period}.",
    "departments": "Departments \/ Divisions",
    "regions": "Regions",
    "noItemsSelected": "No items selected",
    "pleaseSelectOne": "Please select at least one item from the list",
    "tracked": "Tracked",
    "starts": "Starts",
    "duration": "Duration",
    "bonus": "Bonus",
    "invited_by": "Invited by",
    "create_team": "Create a team",
    "discardConfirmation": "Are you sure you want to exit?",
    "discardYes": "Yes",
    "discardStay": "Go back",
    "create_team_toast_title": "Create team",
    "edit_team": "Edit team",
    "team_edits_submitted": "Your team has been updated.",
    "challenge_ended_still_trackable": "This %{type} has ended, fortunately you have %{num} days remaining to track!",
    "tracking_period_ended": "The tracking period for this %{type} has ended.",
    "unlimited": "Unlimited",
    "ends_in": "Ends in",
    "challenge_toast": {
        "success": {
            "join": "Success!",
            "message": "You have successfully joined the challenge."
        },
        "danger": {
            "error": "Error",
            "message": "Something went wrong. Try joining the challenge again in a little while."
        }
    },
    "members_to_invite": "Members to invite",
    "members_to_remove": "Members to remove",
    "myChallenges": "Competitions",
    "upcoming": "Upcoming",
    "myPersonalGoals": "Goals",
    "companyCompetitions": "Company competitions",
    "communityCompetitions": "Community competitions",
    "edit_your_team": "Edit your team",
    "emails": "Emails",
    "CompletedOverall": "Completed overall",
    "TotalEarned": "Total earned",
    "notify_header": "I would like to be notified:",
    "AdditionalBonus": "Additional bonus",
    "goalEndedNotification": "Goal ended, keep pushing yourself!",
    "compEndedNotification": "Competition ended, keep pushing yourself!",
    "congrats_tracking_first": "Congrats on tracking your first activity!",
    "keep_tracking": "Keep tracking your activity to achieve goals and level up.",
    "understanding_tracking": "Understanding tracking",
    "cannot_track_this_day": "You cannot track on this day.",
    "nothing_tracked_this_day": "You have not yet tracked this day.",
    "tracked_something_this_day": "You've tracked something for this day.",
    "reached_goal_this_day": "You've reached your goal for this day (only for daily goals).",
    "got_it": "Got it!",
    "notDismissedMultiTitle": "Challenge summary",
    "notDismissedMultiSubtitle": "A few challenges have ended. Take a deeper look into each for details on how you did. ",
    "daySummary": "%{userName}, here is a summary of your day so far",
    "goals": "Goals",
    "competitions": "Competitions",
    "totalAccumulated": "Total accumulated",
    "tracking_for_date": "Tracking for %{date}",
    "activity_tracker_instruction": "Tap to edit or remove a manually tracked activity",
    "ended": "Ended",
    "notYetAvailableBeta": "Not yet available in beta",
    "suggestedGoal": "Suggested goal",
    "singleFor": "for",
    "seeLessLongComment": "See less",
    "synced_data": "Synced data:",
    "doThisLater": "I will do this later",
    "inviteUsers": "Invite others to join",
    "cannotTrackAfterDeadline": "You are trying to track an activity for a date after the challenge deadline.",
    "potentialBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} bonus %{customPoints} are available for this goal!",
            "titleNotCompleted": "You missed the %{potentialBonusPoints} bonus %{customPoints} by %{activitytCompletedPercentage}%.",
            "titleCompleted": "Congratulations! You've earned",
            "titleCompletedBold": "%{potentialBonusPoints} bonus %{customPoints}!",
            "subtitle": "Learn more about bonus %{customPoints}"
        },
        "modal": {
            "title": "Bonus %{customPoints}",
            "desc1": "We know that no one is perfect and can't complete their goals 100% of the time.",
            "desc2": "That's why we award bonus %{customPoints} when your overall progress is 85% or above.",
            "desc3": "All bonus %{customPoints} are awarded after the goal has ended and if all your tracking was from a connected app or device, you'll receive double bonus %{customPoints}!",
            "desc4": "You won't receive bonus %{customPoints} for goals that you leave early."
        },
        "msg": {
            "title": "This goal has ended",
            "subtitle": "Goal ended on %{goalEndedDate}"
        },
        "msgEnded": {
            "title": "Time's up! Your goal has ended",
            "subtitle": "You have %{daysNum} %{daysOrDay} to track your activity."
        }
    },
    "finish": "Finish",
    "personalGoal": {
        "all_goals": {
            "selected": "All %{maxGoals} goals set!",
            "description": "Is this to your liking? You can replace any goals if you change your mind. Don't worry, you will be able to unset your goal later.",
            "set": "All goals have been set!",
            "action": "All set, good to go!",
            "error": "Let’s not get carried away! Focusing on at most 3 structured goals at a time will increase your likelihood of success.",
            "errorHeading": "Setting goals"
        },
        "set_more": "You can set %{maxGoals} more active goals",
        "select_goal": {
            "heading": "Set a recommended goal or create your own"
        },
        "set_more_1": "You can set 1 more active goal"
    },
    "restartPersonalGoal": "Restart goal with new targets",
    "delete_challenge_confirmation": "Are you sure you want to delete this challenge?",
    "personal_goal_unit": "goal",
    "personal_goal_units": "goals",
    "day_summary": {
        "steps_taken": "Steps taken",
        "calories_in": "Calories in",
        "calories_out": "Calories out",
        "avg_daily": "avg. daily",
        "most_earned_daily": "most earned a day"
    },
    "invitedBy": "Invited by %{person}",
    "resetPasswordMissingField": "Please enter an email",
    "resetPasswordInvalidValue": "Please enter a valid email address",
    "resetPasswordNotFound": "Your email cannot be found",
    "resetPasswordNotCompleted": "Your request could not be completed",
    "resetGoalInstructions": {
        "start": "Do %{quantity} %{units} of %{activity}",
        "additional": ", %{quantity} %{units} of %{activity}",
        "end": "%{frequency} and earn %{points} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "One goal set. View",
        "two": "Two goals set. View",
        "three": "Three goals set. View",
        "none": "No goals set. Set goals"
    },
    "searchCommunitiesEmpty": "No communities found",
    "searchCommunitiesPlaceholder": "Search communities",
    "updating": "Updating...",
    "pts_tracked": "Tracked %{activityName} - %{num} %{customPoints}",
    "improving_wellbeing_score": "Keep up the good work, you're on your way to improving your wellbeing score.",
    "progressHistory": "Progress history",
    "privateCommunity": "This is a private community",
    "do_combo_of_activities": "Do any combination of the following.",
    "noActivitiesTracked": "No activities tracked",
    "trackingWithFollowingApps": "Tracking with the following apps\/devices",
    "recommendedApps": "Recommended apps\/devices for this %{challengeType}",
    "collapseWord": "Collapse",
    "started": "Started",
    "ends": "Ends ",
    "do_activities": "Do activities",
    "rewards_placeholder": "Example rewards from the store, placeholder. Users will see various products they can purchase and the cost in %{rewardName}.",
    "personalGoals": {
        "top": {
            "label": "Top"
        },
        "allGoals": "All goals",
        "seeMoreCard": {
            "heading": "Don't see what you are looking for?",
            "description": "Take a look at all recommended goals",
            "button": "Explore goals"
        }
    },
    "rewardsNotAvailable": "Rewards are presently not available in this beta. When available, you will be able to view the catalogue and complete a redemption.",
    "editProfileProvideRestingHeartRate": "Please provide a valid resting heart rate value of at least 40",
    "liveBetterHealthInfo": "We run a number of programs and have a variety of health content designed to support a range of health needs and help you achieve Better Health. We don’t yet have programs for every health condition and need – we’re working on that! – however if you answer the following questions, we will reach out to you if we identify any health programs or services that you may benefit from participating in and\/or send you evidence-based information that will help you better understand and manage your health needs. Please note, we do not use this information to assess the appropriateness of your policy. If you'd like to find out what you're covered for or have any questions about your policy, you can call our Customer Connect team on 132 331.",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "You have deleted the goal"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "You have deleted the challenge"
        }
    },
    "invitations": "Invitations",
    "learnMorePeriods": "Learn more about periods",
    "tracked_by_app_name": "Tracked by %{app_name}",
    "device_required": {
        "text": "This %{challengeType} requires an app or device",
        "button": "Connect an app or device"
    },
    "editingCommunityToast": {
        "success": {
            "title": "Edit community",
            "message": "Community has been edited"
        }
    },
    "competition": "Competition",
    "close": "Close",
    "only_automatic_activities_with_device": "This %{goal_or_competition}'s activities are tracked automatically with your connected apps\/devices.",
    "only_automatic_activity_with_device": "This %{goal_or_competition}'s activity is tracked automatically with your connected apps\/devices.",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "Community deleted"
        }
    },
    "teamSizeMessage": "Your team needs at least %{min} people to earn %{customPoints} for the challenge.",
    "captain": "Captain",
    "inviteOthersToTeam": "Invite others to my team",
    "loadingMetrics": "Connecting to sources to update your day...",
    "aboutTeamSize": {
        "title": "Team size",
        "text": "%{min} to %{max}"
    },
    "pointsOverview": "%{customPoints} overview",
    "deepLinks": {
        "requestCouldNotBeCompleted": "Your request could not be completed",
        "error": "Error"
    },
    "required_lc": "required",
    "personal": "Personal details",
    "biometrics": "Biometrics",
    "makeSelection": "Make a selection",
    "ask_question_success_msg": "Thank you. We'll answer as soon as we can.",
    "report_issue_success_msg": "Thank you. We'll answer as soon as we can.",
    "ask_question_success_title": "Question submitted",
    "report_issue_success_title": "Technical issue submitted",
    "ask_question_failure_msg": "Bummer... There was an error submitting your question, please try again.",
    "report_issue_failure_msg": "Bummer... There was an error reporting your issue, please try again.",
    "notTrackedActivities": "You have not tracked any activities for this period",
    "learn": "Learn",
    "Balance": "Balance",
    "details": "Details",
    "Reward": "Reward",
    "levelsReset": "Levels reset in %{remainingDays} days",
    "redeem": "Redeem",
    "redeemAt": "Redeem at %{points}",
    "needPointsToRedeem": "You need %{points} more %{rewardName}.",
    "learnEarnMore": "Learn how to earn more",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "Join team",
            "message": "You've successfully joined the team!"
        },
        "danger": {
            "message": "We've encountered an error and could not find the team. It may no longer exist."
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "Action not available",
            "message": "Your request could not be completed."
        }
    },
    "transactionLog": "Transactions",
    "orderHistory": "Orders",
    "pointsAvailableToEarn": "%{points} available to earn",
    "missedYTD": "%{missed} missed YTD",
    "rewardsDetails": "Rewards",
    "successfullyRedeemedItem": "You've successfully redeemed this item",
    "orderNumber": "Order number",
    "amountSpent": "Amount spent",
    "status": "Status",
    "dateRedeemed": "Date redeemed",
    "additionalInformation": "Additional information",
    "shipToAddress": "Ship to this address",
    "pointMissedYearToDate": "%{rewardCurrencyName} missed this year",
    "pointMissedYearToDateDescription": "When you don't achieve a level before the period ends, the associated %{rewardCurrencyName} you could have earned are considered missed.",
    "NoLibraryContentToast": {
        "info": {
            "title": "Article not found",
            "message": "Could not find article. It may be removed or no longer available."
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "Community not found",
            "message": "Could not find community. It may be removed or no longer available."
        }
    },
    "shippingAddress": "Shipping \/ billing address",
    "enterShippingAddress": "Enter your shipping \/ billing address",
    "streetLine": "Street line %{num}",
    "stateProvince": "State\/Province",
    "postcodePostalcodeZip": "Postcode\/Postalcode\/Zip code",
    "phoneNumber": "Phone number",
    "order": "Order",
    "redemptionConfirmation": "Redemption confirmation",
    "edit": "Edit",
    "processing": "Processing",
    "checkIsYouFirst": "We just need to check if it's you first",
    "discardSomeGoals": "You have set some goals. These goals will be discarded if you proceed.",
    "settingGoalsToast": {
        "success": {
            "message": "Your new goals have been set!"
        }
    },
    "one_team": "1 team",
    "noAchievementsToEarnMessage": "It looks like there are no more badges to earn %{rewardCurrencyName} this period.",
    "shopRewards": "Shop rewards",
    "validateShippingAddressToast": {
        "danger": {
            "title": "Shipping \/ billing address",
            "message": "Please complete all fields before continuing."
        }
    },
    "viewDetails": "View details",
    "potential": "Potential",
    "missed": "Missed",
    "rewardsStoreNotAvailable": "The rewards store is not available for you at the time.",
    "havent_tracked_in_a_while_date": "No activities tracked for %{currentDate}",
    "challengeNotFoundToast": {
        "danger": {
            "title": "Challenge not found",
            "message": "Could not find challenge. It may be removed or no longer available."
        }
    },
    "shareYourDaySubtitleActivity": "Add a picture or say something about this activity!",
    "goal_ended": "Goal ended",
    "challenge_ended": "Challenge ended",
    "day_remaining_to_track": "You have 1 day to track any missed activity",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} ended on %{endDate}",
    "goalEndedModal": {
        "title": "Catch up on forgotten activity",
        "message": "After a personal goal or challenge has ended you have three days from the end date to track any activities you may have forgotten. After this grace period, you cannot track any additional activities that contribute to the goal or challenge."
    },
    "summary": "Summary",
    "placedRank": "You are placed %{rank} of %{total}",
    "rank": {
        "first": "1st",
        "second": "2nd",
        "third": "3rd",
        "n": "%{rank}th"
    },
    "event_name": "Event name",
    "this_is": "This is a  ",
    "location_info": "Location & info",
    "what_event": "What is this event about",
    "event_is": "This event is",
    "start_on": "Start on:",
    "end_on": "End on:",
    "location": "Location",
    "chooseLeaderboard": "Choose a leaderboard",
    "filterOneOfFollowing": "Filter one of the following",
    "showChallengeInstead": "Show a challenge instead",
    "showActivityInstead": "Show an activity instead",
    "showAll": "Show all",
    "activitiesShowSame": "Activities: %{activityName}",
    "challengeShowSame": "Challenge: %{challengeName}",
    "chooseTimePeriod": "Choose a time period",
    "youCanFilterOneAtTime": "One filter can be selected at a time",
    "saveHealthTopicsToast": {
        "success": {
            "message": "Health topics saved",
            "title": "Success!"
        },
        "info": {
            "message": "Unable to save"
        },
        "danger": {
            "title": "Error!"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "Health objectives saved",
            "title": "Success!"
        },
        "info": {
            "message": "Unable to save"
        },
        "danger": {
            "title": "Error!"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "Interests saved",
            "title": "Success!"
        },
        "info": {
            "message": "Unable to save"
        },
        "danger": {
            "title": "Error!"
        }
    },
    "edit_event": "Edit event",
    "leave": "Leave",
    "delete_event": "Delete event",
    "no_events": "No events",
    "no_events_placeholder": "You are not currently planning to attend any future events. Why don't you join one?",
    "event": "event  ",
    "challenge": "Challenge",
    "invited_you": "Invited you",
    "public": "Public",
    "private": "Private",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Event deleted successfully."
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "You have left the event"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Event updated successfully."
        }
    },
    "createEventToast": {
        "success": {
            "message": "Event created successfully.",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "The content you're trying to view is not currently available. It may have been deleted by the author or marked as inappropriate.",
    "start_time": "Start Time",
    "end_time": "End Time",
    "event_type": "%{eventType} event",
    "leave_event_modal": {
        "title": "If you leave this event",
        "message": "It will be deleted"
    },
    "leave_event ": "Are you sure you want to leave this event?",
    "create_event": "Create event",
    "created_by": "Created by",
    "eventActionToast": {
        "danger": {
            "title": "Error",
            "message": "Something went wrong. "
        }
    },
    "continue": "Continue",
    "wantExitTour": "Are you sure that you want to exit the tour?",
    "exitTour": "Exit tour",
    "deleveEventPopup": "Are you sure you want to delete this event?",
    "attendeesTitle": "Attendees",
    "userEvents": "%{name}'s events",
    "createEventIndicator": "Creating event",
    "inviteToEvent": "Invite to event",
    "noDescription": "There is no description.",
    "leaderboardIsEmpty": "This leaderboard is empty or you may need to track activity within the selected time period to view it",
    "notParticipantingInAnyChallenges": "You are not participating in any challenges",
    "buttonLeaveEvent": "Leave event",
    "leaveEvent ": "Leave %{name}?",
    "canceledCreatingChallenge": "Creation of a %{challengeType} is cancelled successfully",
    "swipeReadNotification": "Read",
    "productTour": {
        "initialScreen": {
            "title": "Welcome to %{programName}!",
            "body": "Let's take a tour and in a few moments you'll know the basics."
        },
        "dashboard": {
            "title": "Dashboard",
            "body": "See how many %{pointsName} you have and your progress towards levels. Then check out the leaderboard to see how you stack up."
        },
        "rewards": {
            "title": "Rewards",
            "body": "See how many %{rewardPointName} you have and redeem them in the store."
        },
        "goals": {
            "title": "Goals & challenges",
            "body": "Your active personal goals, challenges with others, and special tasks can be found here."
        },
        "explore": {
            "title": "Explore",
            "body": "Find challenges with others, join communities to discuss your interests, and discover a new article in the wellbeing library."
        },
        "me": {
            "title": "Me",
            "body": "Find your wellbeing score, check your stats, and edit your profile & settings here."
        },
        "finishScreen": {
            "title": "You're all set",
            "body": "Thank you for completing the tour.",
            "button": "Let's get started"
        },
        "skip": {
            "title": "Are you sure you want to skip the tour?",
            "body": "This will end the tour and you can get started right away."
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "Authentication failure",
            "message": "Could not proceed with reward redemption. An error occured while authenticating with reward provider."
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "Redemption failed",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "Before you begin",
    "disclamerSectionMessage": "Check with your healthcare professional before starting any new exercise program or making lifestyle changes to ensure they are suitable for you.",
    "noEarchedAchievements": "You have not yet earned any achievements. Track an activity to get started.",
    "noInProgressAchievements": "You have no achievements in progress.",
    "discardCreatingEventMessage": "Check that all required fields have been entered",
    "discardCreatingEventTitle": "Event cannot be created",
    "discardEditedEventTitle": "Event cannot be edited",
    "errorEventNameMessage": "Name is required",
    "errorEventStartDateMessage": "Start date is required",
    "errorEventEndDateMessage": "End date is required",
    "errorEventDateMessage": "The end date cannot be earlier than the start date",
    "noAccountsToLink": "There are no accounts available to link to %{program_name}.",
    "accountLinkEmailChanged": "Your email address has been updated. Going forward, log in with your linked account.",
    "accountLinkSuccessful": "Your account was successfully linked.",
    "edit_profile_nan_value": "The value must be a number",
    "advancedLogIn": "Advanced log in",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "Redemption failed",
            "message": "Order session has expired. Please try placing order again."
        }
    },
    "left": "left",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "It seems like there are no events available to join at this time. Why don't you create one?"
        }
    },
    "reachedHighestLevel": "You've reached the highest level!",
    "error": "Error",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "Reward redemption",
            "message": "Your order has been placed"
        }
    },
    "redeemRewardComplete": "Redemption complete",
    "trackActivityTitle": {
        "oneUnit": "Track: 1 %{unit} of %{activity} on %{date}",
        "nUnit": "Track: %{activity} for %{date}"
    },
    "ssoAuthenticationFailure": "Authentication failure",
    "earnEvery": "Earn every %{frequency}",
    "earnOnce": "Earn once only",
    "goalSettings": {
        "maximumSet": "You currently have the maximum of 3 goals set.",
        "learnMore": "Learn more about goal setting"
    },
    "allowMarketingComms": "Send me promotional communications",
    "allowPartnerMarketingComms": "Send me promotional communications from partners",
    "noUpcomingAchievements": "You have no upcoming achievements.",
    "settingGoalToast": {
        "success": {
            "message": "Your new goal has been set!"
        }
    },
    "authentication": {
        "saml": {
            "error": "Service currently unavailable",
            "signin": "Integrated sign in",
            "signup": "Integrated sign up"
        }
    },
    "monthName": {
        "january": "January",
        "february": "February",
        "march": "March",
        "april": "April",
        "may": "May",
        "june": "June",
        "july": "July",
        "august": "August",
        "september": "September",
        "october": "October",
        "november": "November",
        "december": "December"
    },
    "promotedForMe": "Featured",
    "appRating": {
        "enjoying": "Enjoying our app?",
        "feedback": "Would you like to provide some feedback?",
        "appStore": "Rate us in the App Store?",
        "googlePlay": "Rate us on Google Play?",
        "notReally": "Not really",
        "yes": "Yes!",
        "sure": "Sure",
        "noThanks": "No thanks",
        "notNow": "Not now"
    },
    "getMobileApp": "To use %{programName} on your smartphone, download %{appStoreName} from the App Store or Google Play.",
    "newAppsDevicesDesign": {
        "getMobileApp": "Download the %{programName} app",
        "searchInAppStore": "Search for %{programName} in your device's app store",
        "getMobileAppNoName": "Get the mobile app"
    },
    "editorAlert": {
        "discardChanges": "Discard changes",
        "saveAndContinue": "Save and continue",
        "title": "Unsaved changes",
        "text": "You have made some changes that have not been saved. What would you like to do?"
    },
    "resources": "Resources",
    "noResources": "No resources available",
    "viewAllResources": "View all resources",
    "language": "Language",
    "eventStarted": "Event started. Registration closed.",
    "Gender": "Sex assigned at birth",
    "show": "Show",
    "hide": "Hide",
    "timeoutError": "Oops! Something is taking too long. Please try again later.",
    "SOT": {
        "sample_task": "Sample Task"
    },
    "cache": {
        "new_version": "A new version is available!",
        "refresh_browser": "Click here to refresh your browser."
    },
    "welcomeUser": "Welcome, %{userFirstName}!",
    "quarter": "quarter",
    "completionReward": "Completion reward",
    "bronzeLevel": "Bronze level",
    "deviceAppSyncingOk": "Device \/ app syncing ok",
    "deviceAppSyncingIssue": "Device \/ app syncing issue",
    "deviceAppSyncingError": "Device \/ app syncing error",
    "lastSync": "Last sync",
    "period": "period",
    "yourDaySummary": "Your day so far",
    "steps": "Steps",
    "gender_non_binary": "Non-binary or non-conforming",
    "take_survey": "Take the survey",
    "social": "Social",
    "finalDay": "Final Day",
    "leaderboard_position": "Leaderboard position",
    "signUp": {
        "apple": {
            "disconnectSettings": "Disconnect %{appName} from ‘Apple ID Password & Security' in Phone Settings to continue signing up"
        }
    },
    "earnPoints": "Earn %{customPoints}. Level up.",
    "getReward": "Get %{rewardName}.",
    "buildHealthyHabits": "Build healthy habits.",
    "highestLevelIndicator": "You've reached the highest level!",
    "highestLevelIndicatorNew": "You’ve completed every level!",
    "trackYourActivity": "To get %{customPoints}, track your exercise and wellness activity.",
    "levelUpToGetRewarded": "As you level up, you’ll be rewarded with %{rewardName}.",
    "levelUpAndEarn": "Your progress resets every %{period}, so you can level up and earn over and over.",
    "levelUp": "Your progress resets every %{period}, so you can level up over and over.",
    "goToLibrary": "Go to library",
    "updateEventIndicator": "Updating event",
    "meTour": {
        "healthSurveyDisabled": "Check your stats, and edit your profile & settings here."
    },
    "createNewGoal": "Create new goal",
    "later": "Later",
    "bonusChallenge": "Bonus challenge",
    "bonusChallengeInfo": {
        "withReward": "You’ll earn %{amount} bonus %{points} for completing at least 85% of this %{challengeType}.",
        "noReward": "You’ll earn a bonus for completing at least 85% of this challenge.",
        "boldText": "%{amount} bonus %{points}",
        "noRewardChallengeType": "You’ll earn a bonus for completing at least 85% of this %{challengeType}."
    },
    "defaultApp": "Your default health app",
    "bonusGoal": {
        "additionalInfo": "If all your activity was tracked using a connected app or device, you'll receive double bonus %{points}!",
        "additionalInfoNew": {
            "paragraph2": "Bonus %{points} are awarded after the goal has ended. You won't receive bonus %{points} for goals that you leave early."
        },
        "boldText": "double bonus %{points}!",
        "markTitle": "Bonus goal"
    },
    "notify_me": "Notify me",
    "bonusChallengeReward": "Bonus challenge reward",
    "forCompletingChallenge": "For completing %{challengeName}",
    "notifications_text": "Notifications help you stick to your goals and keep up with conversations.",
    "type_here": "Type here",
    "bonusEarned": "Bonus earned",
    "youEarnedBonus": "You earned this bonus!",
    "inviteOthersToChallenge": "Invite others to join challenge",
    "inviteOthersToYourTeam": "Invite others to your team",
    "manageTeam": "Manage team",
    "ft": "ft",
    "lbs": "lbs",
    "cm": "cm",
    "kg": "kg",
    "community": "community",
    "chooseActivity": "Choose activity",
    "Recent": "Recent",
    "noActivities": "No matching activities",
    "photoChooseText": "Choose",
    "photoCancelText": "Cancel",
    "signIn": {
        "missingEmail": "Missing email address",
        "missingPassword": "Please ensure the password is provided",
        "invalidLogin": "Invalid login",
        "accountLocked": "Your account is locked. Please contact your administrator",
        "accountMayNotExist": "We don’t have an account for this email address. Sign up to create an account.",
        "wrongPassword": "Wrong password. Try again or click Forgot Password to reset it."
    },
    "deleteGoalBonusPoints": "If you haven’t earned the associated bonus yet, you will no longer be able to.",
    "havent_tracked_goal": "You haven’t tracked any activities for this goal",
    "trackActivity": {
        "search": "Search activities...",
        "text": "Track activity",
        "done": "Done",
        "discardChanges": "Discard changes?",
        "discardMessage": "Are you sure you want to exit and discard your progress?",
        "discard": "Discard",
        "limitMessage": "You can only track up to seven days at a time.",
        "inputDescription": "Amount of %{activity} for %{date}",
        "gracePeriod": "You have %{n} %{text} to track any missed activity"
    },
    "dates": "Dates",
    "pickDates": "Pick other dates",
    "selectDates": "Select dates",
    "limitReached": "You’ve hit the limit",
    "activity": "Activity",
    "keepUpTheGoodWork": "Keep up the good work!",
    "activityTracked": "Activity tracked",
    "new": "New",
    "newFeatureTitle": "Easier, faster activity tracking",
    "newFeatureText": "Whether you’re tracking activity from today, from the past, or for multiple days, we think you’ll love the new experience.",
    "gotIt": "Got it!",
    "frequencyViewHistory": "View %{frequency} breakdown",
    "challengeDetails": {
        "trackTheseActivities": "Track any of these activities to make progress towards this %{challengeType}."
    },
    "member": "member",
    "weeklyBreakdown": "Weekly breakdown",
    "setGoals": {
        "earnPointsText": {
            "start": "Earn",
            "end": "for setting your first goal!"
        }
    },
    "weeklyGoalEnded": "Week ended on",
    "weekFinished": "You finished a week of",
    "restartGoal": {
        "daysLeftToTrack": "You still have %{quantity} %{days} to track any forgotten progress from last week.",
        "weekEnded": "This week has ended.",
        "timesUp": "Time's up!",
        "period": {
            "title": "Goal period",
            "text": "Monday to Sunday, every week"
        }
    },
    "membersPlural": "Members",
    "startedADayAgo": "Started 1 day ago",
    "goalRestarted": "You restarted this goal",
    "weeklyGoals": "Weekly goals",
    "weeklyGoalsDescription": "Weekly goals renew themselves every Monday, so you can keep up a healthy habit over a long period of time.",
    "challengeEnded": "This %{challengeType} has ended",
    "goalEndedModalTitle": "Time's up! Your %{challengeType} has ended!",
    "yourProgress": "Your progress",
    "earn_withRewards": "Subaybayan ang iyong malusog na aktibidad upang kumita ng (%{pts}) at makapasa sa mga antas. Kapag nag-level up ka, makakakuha ka ng %{currency}.",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "Current Period",
    "currentScore": "Current Score",
    "viewActivityLog": "View activity log",
    "balanceHistory": "My balance history",
    "mymedibank": {
        "underAge": {
            "error": "The Live Better app is only available to users 18 years of age and above, please refer to the Live Better T&Cs for more information."
        }
    },
    "enhancedHomePageInfo": "We’ve tidied up the Home page! It’s now easier to see your challenges and goals. Time to get tracking!",
    "levelUpTitle": "Level up",
    "levelUpDescription": "Pass levels by tracking activities and completing goals and challenges. As you level up, you’ll be rewarded with %{currency}!",
    "achievementsDescription": "Unlock these special badges to earn %{currency}. Click on a badge to see what you need to do.",
    "bonusChallengesDescription": "Join and complete challenges that have a %{currency} bonus.",
    "earnWithPartners": {
        "title": "Earn with partners",
        "description": "Medibank members with hospital or extras cover can earn points on eligible purchases\/activity with partners."
    },
    "browseAllPartners": "Browse all partners",
    "resetsIn": "Resets in %{daysNumber} days",
    "thisIsALot": "This is a lot!",
    "areYouSure": "Are you sure?",
    "trackingALotMessage": {
        "days": "You’re tracking over 2,000 %{customPoints} on %{daysNum} days. That’s quite a lot!",
        "day": "You’re tracking over 2,000 %{customPoints} on 1 day. That’s quite a lot!"
    },
    "amSure": "I’m sure",
    "activeMinutesAndSleep": {
        "title": "Device tracking for active minutes and sleep",
        "description": "Your device records active minutes during moderate or high intensity physical activity—that’s good quality exercise! Using a device to track your sleep? You’ll earn %{points} for that too!"
    },
    "hourShort": "hr",
    "hoursShort": "hrs",
    "secondsShort": "sec",
    "watchToEarn": "Watch to earn",
    "oneParticipant": "1 participant",
    "oneTeam": "1 Team",
    "numberOfTeams": "%{num} teams",
    "inviteToYourTeam": "Invite to your team",
    "inviteToThisChallenge": "Invite to this challenge",
    "challengeInstructionText": "Track this activity to make progress towards your %{challengeType}.",
    "showLess": "Show less",
    "startsTomorrow": "Starts tomorrow",
    "deadlineDayLeft": "day left",
    "deadlineDaysLeft": "days left",
    "deviceBonus": "device bonus",
    "appsAndDevices": {
        "header": "Apps and devices",
        "linked": "These linked apps and devices are tracking towards this %{challengeType}:",
        "noLinked": "No applicable apps or devices linked",
        "link": "Link your phone, watch, or app to track automatically."
    },
    "yourGoals": "Your goals",
    "yourChallenges": "Your challenges",
    "position": "Position",
    "team_success": "Team success",
    "starts_in": "Starts in",
    "team_challenge": "Team challenge",
    "your_progress_today": "Your progress today",
    "your_daily_avarage": "Your daily average is",
    "this_week_progress": "This week’s progress",
    "this_month_progress": "This month’s progress",
    "overall_progress": "Overall progress",
    "complete": "complete",
    "overallSuccess": "Overall success",
    "teamSuccessAverage": "Team success average",
    "progressDetails": "Progress details",
    "dayStreak": "%{n}-day streak!",
    "weekStreak": "%{n}-week streak!",
    "dailyProgress": "Daily progress",
    "participantsSuccessCount": {
        "overall": "%{amount} of %{total} participants have hit the target",
        "day": "%{amount} of %{total} participants have hit the target today",
        "week": "%{amount} of %{total} participants have hit the target this week",
        "month": "%{amount} of %{total} participants have hit the target this month"
    },
    "doubleBonusShort": "Double bonus!",
    "doubleBonusLong": "You earned a double bonus!",
    "recommendedGoalDescription": "Goals help you keep track of your progress and stay motivated!",
    "noParticipation": "No participation",
    "nothingToShow": "Looks like there’s nothing to show right now",
    "yourTeam": "Your team",
    "no_activity_title": "No activity",
    "brandSupport": {
        "description": "We’ve added support for activity syncing with Polar and Withings smartwatches. Time to get moving!"
    },
    "no_tracked_activities": "You haven’t tracked any activities yet.",
    "button_leave_community": "Leave community",
    "button_delete_challenge": "Delete %{challengeType}",
    "button_delete_community": "Delete community",
    "button_delete_activity": "Delete activity",
    "library_header_description": "Original content to educate, engage and inspire you in your wellness journey.",
    "library_searchbar": "Search the library…",
    "library_page_header": "Original content to educate, engage, and inspire you in your wellness journey.",
    "onboarding_button_title": "I'm Done",
    "refresh_bar": "Click here to update",
    "content": {
        "min_read": "%{readingTime} min read"
    },
    "noMembers": "No members",
    "saved": "Saved",
    "forYou": "For you",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction} by",
    "youCanEarnThisBadge": "You can earn this badge once every %{period}",
    "emailPreferences": "Email preferences",
    "unsubscribeText": "Opt out of all email updates",
    "savingText": "Saving...",
    "wrongTryLater": "Something went wrong. Please try again later.",
    "preferencesSaved": "Preferences saved",
    "recommendedForYou": "Recommended for you",
    "formerMember": {
        "label": "Former member"
    },
    "selectionsFromLibrary": "Selections from our library picked just for you",
    "goalsInfo": {
        "desc1": "to focus on improving your wellbeing",
        "desc2": "You have the maximum number of goals set."
    },
    "createMyOwn": "Create my own",
    "isAllSet": "is all set!",
    "undoLabel": "Undo",
    "terms": "Terms",
    "placeOrder": "Place order",
    "item": "Item",
    "redeemFor": "Redeem for",
    "confirmYourOrder": "Confirm your order",
    "orderComplete": "Order complete",
    "redeemedFor": "Redeemed for",
    "orderDetails": "Order Details",
    "bonusGoalReward": "Bonus goal reward",
    "orderSummary": "Order summary",
    "logoutSSO": {
        "title": "You’ve signed out of %{programName}.",
        "description": "See you again soon!",
        "signinAgain": "Click here to sign in again"
    },
    "nothing_to_show": "Nothing to show right now",
    "no_saved_content": "You don’t have any saved content",
    "restarts_every_week": "Restarts every week",
    "myGoals": "My Goals",
    "goalGallery": "Goal gallery",
    "share_smth": "Share something…",
    "newFeatureModal": {
        "smartGoal": {
            "title": "Our step goal just got smarter!",
            "description": "Your weeks are always different – now your targets are too! \nWith Smart Mode, your step goal will adjust itself based on your real-life activity.\nIt's set with your success and wellbeing in mind.",
            "action": "Check it out!"
        },
        "mePage": {
            "title": "The new Me",
            "description": "We redesigned the Me section to make finding the things you care about easier – check it out!",
            "letsSeeBtn": "Let’s see!",
            "llaterBtn": "Maybe later"
        },
        "bellEAP": {
            "title": "",
            "description": "",
            "button": "Kumonekta ngayon o bisitahin ang pahina ng Mga Mabilisang Link anumang oras"
        },
        "quickActivityLogView": {
            "title": " Isang mas mabilis na paraan upang makita ang iyong kamakailang aktibidad",
            "description": "Maaari ka na ngayong mag-click sa progress bar upang makita ang iyong log ng aktibidad."
        }
    },
    "goalSmartMode": {
        "title": "Smart Mode",
        "description": "Get personalized weekly targets based on your recent activity level.",
        "status": "Smart Mode is %{status} for this goal.",
        "infoModal": {
            "descriptionOne": "When Smart Mode is on, the target for this goal will change week-to-week based on your recent activity level.",
            "descriptionTwo": "We'll challenge you just the right amount to set you up for success.",
            "instructions": ""
        },
        "settings": {
            "switch": "Enable Smart Mode for my step goal",
            "description": "When Smart Mode is on, you’ll get a new step target at the beginning of every week."
        },
        "enableSmartMode": "Enable Smart Mode",
        "settingsModal": {
            "descriptionTurnOn": "Your step goal target will change every week based on your activity",
            "descriptionTurnOff": "Your step goal target will no longer be personalized every week"
        }
    },
    "On": "On",
    "Off": "Off",
    "top_posts": "Top posts",
    "most_recent": "Most recent",
    "browseByTopic": "Browse by topic",
    "video": "Video",
    "enable": "Enable",
    "turnOff": "Turn off",
    "new_post": "New post",
    "new_post_in": "New post in",
    "dailyTarget": "Daily target",
    "dailyTargetForWeek": "Daily target for the week",
    "showMyActivityLog": "Show my activity log",
    "usersReacted": {
        "oneOther": "%{userName} and 1 other",
        "multipleOthers": "%{userName} and %{count} others"
    },
    "reactionsModal": {
        "title": "More ways to celebrate",
        "description": "Cheer on your colleagues with new social post reactions!"
    },
    "account": "Account",
    "myWellbeingProfile": "My wellbeing profile",
    "physicalDetailsDescription": "This information is needed to calculate your wellbeing score",
    "wellbeingInterests": "Wellbeing interests",
    "myWellbeingInterests": "My wellbeing interests",
    "preferredNameOptional": "Preferred name (optional)",
    "basicPhysicalDetails": "Basic physical details",
    "notRegistered": {
        "infoModal": {
            "title": "We can't find you",
            "notInSystem": "isn’t in our system.",
            "correctEmail": "Be sure to use the correct account (usually a company email address) and check for typos.",
            "emailHelp": "For more help, email our support team at"
        }
    },
    "dontHaveAccount": "Don't have an account?",
    "wasThisHelpful": "Was this helpful?",
    "healthScoreFeedbackModal": {
        "emojiSection": "How helpful is this page and your wellbeing score?",
        "commentSectionText": "How could they be improved?",
        "commentSectionPlaceholder": "Add a comment...",
        "thankYouModal": "Thanks for your feedback!"
    },
    "number_connected": "%{numDevices} connected",
    "searchPlaceHolder": "Search...",
    "noTeamsFound": "No teams found",
    "join_a_challenge": "Join a challenge",
    "me_page_titles": {
        "goal": {
            "singular": "goal",
            "plural": "goals"
        },
        "challenge": {
            "singular": "challenge",
            "plural": "challenges"
        }
    },
    "seeMoreText": "…see more",
    "adjust_entry": "Please adjust entry.",
    "overTracking": {
        "title": "Over-tracking warning",
        "desc1": {
            "singular": "This entry will be audited.",
            "plural": "These entries will be audited."
        },
        "desc2": "Intentional over-tracking may result in account suspension.",
        "button_edit": "Edit my entries",
        "button_confirm": "Submit as-is"
    },
    "oneEventAttendee": "1 attendee",
    "multipleEventAttendees": "%{num} attendees",
    "to": "to",
    "eventBonusFull": "You’ll earn %{number} bonus %{points} for attending this event. ",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "Did you like this article? ",
    "didYouLikeVideo": "Did you like this video?",
    "tellUsMore": "Tell us more...",
    "thanksForFeedback": "Thanks for your feedback!",
    "challengesSubtitle": "Reach a target alongside other participants—or play to win! ",
    "appStoreNameSprout": "Sprout at Work",
    "appStoreNameLiveBetter": "Medibank Live Better",
    "appStoreNameTelus": "TELUS Health Wellbeing",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Telus Health Virtual Care",
    "virtualCare": "Virtual Care",
    "changePassword": {
        "telus": {
            "info": "Your password is managed through your %{telusVC} account.",
            "button": "Change my %{virtualCare} password"
        }
    },
    "actions": "actions",
    "onAndUpcoming": "On & upcoming",
    "termsAndPrivacyPolicyNew": "By continuing, you agree to the",
    "invitedToTeam": "Invited to %{firstName} %{lastName}'s team",
    "decline": "Decline",
    "invitedToChallenge": "Invited by %{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "You don't have any goals set"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "You aren’t in any challenges",
        "buttonLabel": "Explore challenges"
    },
    "menu": "Menu",
    "everyone": "Everyone",
    "confirmEmployeeID": "Confirm Employee ID",
    "employeeIDNoMatch": "These IDs don’t match yet",
    "hidePost": "Hide posts by %{ownerName}",
    "hidingUserPostToast": {
        "success": {
            "title": "User Hidden",
            "message": "You won’t see posts by this user anymore."
        }
    },
    "moderateHideUserDescription": "Hiding posts for this user will remove user specific content from the stream.",
    "startsInOneDay": "Starts in 1 day",
    "endsInOneDay": "Ends in 1 day",
    "endsToday": "Ends today",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "isn't in our system. Did you enter that correctly?",
            "administrator": "If you're a new employee, we may not have your Employee ID yet. Please ask your administrator about when to try again.",
            "emailNotInSystem": "Kung ikaw ay isang bagong empleyado, ang iyong email ay maaaring hindi pa naidagdag sa aming system. Mangyaring tanungin ang iyong administrator kung kailan susubukan muli.",
            "eligibleEmail": "ay hindi isang karapat-dapat na email address. Tama ba ang naipasok mo?"
        }
    },
    "oneMember": "1 member",
    "programCode": {
        "infoModal": {
            "unique": "Your company has a unique program code that is usually provided to you in an email.",
            "support": "If you can’t find your code, contact your wellness program administrator or email support@sproutatwork.com with your company name."
        },
        "instructions": "Enter the program code provided by your employer to get started"
    },
    "whatsMyProgramCode": "What’s my program code?",
    "enjoyApp": "Enjoy our mobile app",
    "programCodeLabel": "Program code",
    "createdByMembersChallenges": "Created by members",
    "invites": "Invites",
    "recommendedContentTitle": "Library picks for you",
    "amountExchanged": "Amount exchanged",
    "orderStatus": "Order status",
    "orderSuccessfulyyItemForConfirmation": "Order successful! A confirmation has been sent to %{email}.",
    "orderedOnDateText": "Ordered on %{orderCreatedTime}",
    "personalize": {
        "communities": {
            "title": "Join communities",
            "description": "Communities connect people with common interests. You can join or leave communities at any time."
        },
        "objectives": {
            "title": "My objectives",
            "description": "What can we help you start or maintain? We’ll use this to improve our recommendations."
        },
        "topics": {
            "title": "My wellbeing topics",
            "description": "You’ll see more tips and how-to content about these selections."
        }
    },
    "recommendedCardDesc": "Set up to 3 goals to focus on improving your wellbeing",
    "accessibility": {
        "track_activity": "Track activity",
        "cardbody": "Card Body",
        "cardcontainer": "Card Container",
        "cardfooter": "Card Footer",
        "unstartedChallengeHeader": "Unstarted Challenge",
        "activeOrEndedChallengeWrapper": "Challenge Wrapper",
        "activeOrEndedChallengeHeader": "Challenge Header",
        "goalHeader": "Goal Header",
        "openOptions": "Open Options"
    },
    "teams": {
        "teamInvites": "Team invites",
        "findTeam": "Find a team",
        "teamFull": "Team is full"
    },
    "deleteAccountText": "Permanently delete your Sprout At Work account and all its data",
    "deleteAccountButtonTitle": "Delete my account",
    "joinTeamActionSheetText": "Join or create a team to participate in this challenge",
    "frequencyNone": "none",
    "quickLinkTitle": "Quick links",
    "moreTab": "More",
    "addedBy": "Added by %{companyName}",
    "teamsTitle": "Teams",
    "helpAndSupport": "App help & support",
    "feedbackTitle": "Give feedback",
    "feedbackDescription": "Tell us what you like about the app, and where we can improve.",
    "leaveTeamAction": "Leave team",
    "teamActions": "Team actions",
    "leaveTeamLeaveChallenge": "Leaving this team means you’re leaving the challenge. You will need to join a team to continue participating.",
    "familyMembers": "Mga miyembro ng pamilya",
    "familyMembersDescription": "",
    "learnMoreButton": "Learn More",
    "thvcSelection": {
        "signUpUsingTelus": "",
        "loginGetStarted": "",
        "haveAccount": "",
        "emailHelp": "",
        "yes": "",
        "signMeUp": ""
    },
    "inviteFamilyMember": {
        "label": "Mag-imbita ng miyembro ng pamilya",
        "btn": "Magpadala ng Imbitasyon",
        "email": "email address*",
        "firstName": "Pangalan*",
        "lastName": "apelyido*",
        "approval": "Kinumpirma ko na mayroon akong pag -apruba na anyayahan ang miyembro ng pamilya na ito sa %{company}",
        "multiSelect1": "Ang miyembro ba ng pamilyang ito ay higit sa edad ng mayorya sa iyong rehiyon?",
        "multiSelect2": "Ang miyembro ba ng pamilyang ito ay hindi bababa sa 16 taong gulang?",
        "confirmTermsPolicy": "Kinukumpirma ko na ako ang legal na tagapag-alaga ng taong ito. Sa aking pananaw, ang umaasa ay may sapat na gulang upang sumang-ayon sa paggamit ng platform, at pumapayag akong sumali sila dito. Ipapaliwanag ko sa umaasa ang pangangailangan para sa responsableng pag-uugali sa platform at kung paano kinokolekta at ginagamit ng platform ang kanilang data.",
        "onTheirBehalf": "sa kanilang ngalan.",
        "confirm": "Oo, kinukumpirma ko ang nasa itaas",
        "warning": "Ang miyembro ng pamilya ay dapat na hindi bababa sa 16 taong gulang upang mag-sign up",
        "errorMsg": "Mangyaring suriin ang mga error bago subukang magpatuloy"
    },
    "deleteFamilyMember": {
        "desc": "Permanente ang pag-delete ng account ng miyembro ng pamilya.",
        "btn": "Tanggalin ang miyembro ng pamilya",
        "confirmation": {
            "title": "Na-delete ang miyembro ng pamilya",
            "desc": "Ang account ng %{fullName} ay tinanggal"
        },
        "areYouSure": "Sigurado ka bang nais mong tanggalin ang account ng %{fullName}?"
    },
    "familyInvitationStatus": {
        "active": "Aktibo",
        "sent": "Ipinadala ang imbitasyon"
    },
    "familyInvitationSent": {
        "title": "Ipinadala ang email ng imbitasyon",
        "desc": "Anyayahan na ipinadala sa %{fullName}"
    },
    "programCodeSignup": "Program code: %{programCode} ",
    "notJoinedCommunityLabel": "Sumali sa komunidad na ito upang makita kung ano ang ibinabahagi ng mga miyembro",
    "moda": {
        "installApp": {
            "title": "Pakitandaan: Maa-access lang ng mga miyembro ng Moda Health ang Sprout at Work sa pamamagitan ng kanilang Dashboard ng Miyembro.",
            "subtitle": "Para gamitin ang Sprout at Work sa iyong smartphone:",
            "stepOneA": "1. I-install ang Sprout at Work mobile app.",
            "stepOneB": "Huwag mag-sign up o mag-log in sa mobile app.",
            "stepTwo": "2. Mag-log in sa iyong Member Dashboard sa iyong mobile phone",
            "stepThree": "3. Mag-browse sa Sprout wellness program at sundin ang link na iyon--dapat itong buksan ang Sprout sa\nWork mobile app.\n\n"
        }
    },
    "HRISLocationSelection": {
        "title": "Saang bansa ka nagtatrabaho?"
    },
    "visibilitySettings": {
        "title": "Mga Setting ng Visibility",
        "desc1": "Okay lang bang maging nakikita ng iba pang miyembro ng Wellbeing app sa iyong kumpanya?",
        "desc2": "Maaari mong baguhin ito palagi sa ibang pagkakataon.",
        "moreTextQ1": "Ano ang nakikita ng ibang tao?",
        "moreTextAnswer1": "Ang iyong pangalan, larawan sa profile, at mga pangunahing detalye ng profile (tulad ng departamento at lokasyon) ay makikita ng mga tao sa iyong kumpanya. Ginagawa nitong mas sosyal at masaya ang app.",
        "moreTextQ2": "Saan ako lilitaw?",
        "moreTextAnswer2": "Ipapakita ka bilang kalahok para sa mga hamon, komunidad, at kaganapang sasalihan mo, sa mga leaderboard, at sa mga resulta ng paghahanap. Maaari mo itong ayusin sa ibang pagkakataon.",
        "moreTextAnswer3": "Hindi namin ibinabahagi o ipinapakita ang iyong personal na impormasyon sa kalusugan, tulad ng iyong taas, timbang o aktibidad na iyong sinusubaybayan.",
        "btnAgree": "Okay lang na magpakita sa akin",
        "btnDisagree": "Huwag hayaang makita ako ng ibang miyembro"
    },
    "privacyPolicyReadMore": "Upang matuto nang higit pa, basahin ang aming Patakaran sa Privacy",
    "tellMeMore": "Sabihin mo pa",
    "helpUsImprove": {
        "title": "Tulungan Kaming Umunlad",
        "desc1": "Gumagamit kami ng mga tool na nagtatala ng hindi kilalang data ng paggamit. Ang pagtingin sa mga trend sa kung ano ang tinitingnan at na-click ng mga tao ay nakakatulong sa amin na gawing mas mahusay ang app.",
        "desc2": "Maaari mong i-off ito anumang oras.",
        "moreTextQ1": "Ang tinitingnan namin",
        "moreTextAnswer1": "Interesado kami sa pangkalahatang mga trend at istatistika, kaya hindi namin tinitingnan ang data sa indibidwal na antas.",
        "moreTextQ2": "Hindi namin ibinabahagi ang iyong data",
        "moreTextAnswer2": "Available lang ang data na ito sa mga taong bumuo ng app na ito para makatulong na mapahusay ito. Hindi namin ito ibinabahagi sa ibang mga kumpanya, kasama ang iyong employer.",
        "moreTextQ3": "Anonymous ang iyong data",
        "moreTextAnswer3": "Ang aming mga tool ay hindi nagtatala ng iyong pangalan, eksaktong lokasyon o anumang personal na impormasyon sa kalusugan.",
        "btnAgree": "Subaybayan ang aking paggamit nang hindi nagpapakilala",
        "btnDisagree": "Hindi ako pumayag sa pagsubaybay"
    },
    "deleteAccountTextAppName": "",
    "anonymousMember": "Anonymous na Miyembro",
    "activitiesToTrack": {
        "title": "Mga aktibidad na susubaybayan"
    },
    "includedInMembership": "",
    "invalidDate": "Invalid date",
    "discardsStreamPost": {
        "discardTitle": "Itapon ang post?",
        "discardChangesTitle": "Itapon ang mga pagbabago?",
        "discardPostText": "Sigurado ka bang gusto mong itapon ang iyong post?",
        "discardPostChangesText": "Sigurado ka bang gusto mong itapon ang iyong mga pagbabago?"
    },
    "trackActivityModalTitle": "Subaybayan para sa %{date}",
    "noPosts": "Walang mga post na makikita",
    "goalIcon": "Icon ng layunin",
    "resetsOn": "Nire-reset sa %{date}",
    "clickForHelp": "Mag-click dito para sa Tulong",
    "trackActivityInputLabel": "Ilagay ang %{unit} %{activityName} %{dateFormat}",
    "itemsFound": "Nahanap ang mga item",
    "tagState": {
        "active": "Aktibo",
        "notActive": "Hindi aktibo"
    },
    "bonusCheckmarkLabel": "Nakatanggap ng %{bonusLabel} na mga puntos ng bonus para sa pagkumpleto",
    "searchBar": {
        "searching": "naghahanap ng %{term}",
        "result": "resulta ng paghahanap"
    },
    "activityProgress": "Pag-usad ng aktibidad - %{levelName} %{percentFilled}% - Nire-reset sa %{daysLeft} araw",
    "bookmark": {
        "remove": "Alisin mula sa mga naka-save na item",
        "save": "I-save ang item na ito"
    },
    "bonusMark": {
        "earn": "Makakuha ng %{qty} %{points}",
        "earned": "Nakakuha ka ng %{qty} %{points}"
    },
    "tabToTrackActivity": "I-tap para subaybayan ang aktibidad",
    "videoElementLabel": "%{title}, tagal %{duration}, I-double tap para mag-play ng video",
    "updatedPoliciesPopup": {
        "title": "Na-update namin ang aming mga tuntunin",
        "details": "Hinihikayat ka naming basahin ang aming na-update na mga patakaran sa ibaba:",
        "disclaimer": "Sa pamamagitan ng pag-click sa button sa ibaba, sumasang-ayon ka at kinikilala ang mga na-update na patakaran.",
        "agree": "Sumasang-ayon ako"
    },
    "editActivityLog": {
        "canNotEditItem": "Hindi mo maaaring i-edit ang entry na ito",
        "canNotEditItemDescription": "Hindi available ang pag-edit para sa mga aktibidad na naka-sync mula sa mga device o app.",
        "updatedItem": "Na-update ang aktibidad",
        "updatedItemDescription": "Nai-save na ang iyong mga pagbabago."
    },
    "login_with_email": "Mag-log in gamit ang email",
    "healthconnect_not_available": "Hindi makakonekta sa Health Connect. Sa Health Connect app, pakitiyak na naka-enable ang mga pahintulot.",
    "registrationField": {
        "required": {
            "firstName": "Pakilagay ang iyong pangalan",
            "lastName": "Pakilagay ang iyong apelyido",
            "email": "Mangyaring magpasok ng wastong email address",
            "password": "Mangyaring magpasok ng wastong password"
        }
    },
    "settingsErrorMessage": {
        "firstName": "Pakilagay ang iyong pangalan",
        "lastName": "Pakilagay ang iyong apelyido"
    },
    "requiredValidValue": "Mangyaring magpasok ng wastong halaga para sa iyong %{value}",
    "passwordHidden": "Nakatago ang password, i-tap para ipakita ang password",
    "passwordShown": "Ipinakita ang password, i-tap para itago ang password",
    "libraryHeaderContent": {
        "category": "",
        "points": "Makakuha ng %{points} na puntos."
    },
    "scoreCurrentPeriod": "Ang %{text} ay mula %{startDate} hanggang %{endDate}",
    "scoreCurrent": "Ang %{text} ay %{points} na puntos",
    "abbotResetPasswordModal": {
        "title": "Sinusubukan mo bang mag-access ng account mula noong nakaraang taon?",
        "text": " Kung nag-sign up ka para sa hamon noong nakaraang taon, hindi na gagana ang account na iyon. Kailangan mong mag-sign up para sa taong ito.",
        "goToResetPasswordBtn": "Nag-sign up ako sa %{currentYear}",
        "goToSignupBtn": "Hindi pa ako nakakapag-sign up sa %{currentYear}"
    },
    "challengeRegistrationClosed": "Sarado na ang Pagpaparehistro - Nagsimula na ang Hamon"
};